/* Translation of en-US.ts. Same keys, in the same order; only the
 * values are translated, and every {{placeholder}} is kept. */
export const notifications = {
  "types": {
    "feature_request_update": {
      "status": {
        "title": "Su solicitud de función está {{featureStatus}}",
        "body": "«{{request}}» está {{featureStatus}}."
      },
      "reply": {
        "title": "Respuesta a su solicitud de función",
        "body": "«{{request}}»: {{reply}}"
      },
      "merged": {
        "title": "Ya solicitada",
        "body": "«{{request}}» ya se había solicitado. Hemos añadido su voto."
      }
    },
    "feature_idea_update": {
      "default": {
        "title": "Una idea que votó está {{featureStatus}}",
        "body": "«{{idea}}» está {{featureStatus}}."
      }
    },
    "work_change_opened": {
      "default": {
        "title": "El trabajo se está cambiando",
        "body": "{{actor}} está cambiando «{{job}}». Se te pedirá que lo aceptes de nuevo."
      }
    },
    "work_changed": {
      "default": {
        "title": "El trabajo cambió. Acéptalo de nuevo",
        "body": "{{actor}} cambió «{{job}}»: {{changes}}. Revísalo y acéptalo de nuevo."
      }
    },
    "quote_scope_changed": {
      "default": {
        "title": "El alcance que estabas presupuestando cambió",
        "body": "{{actor}} cambió «{{job}}»: {{changes}}. Presupuesta de nuevo el nuevo alcance."
      }
    },
    "work_accepted_longer": {
      "default": {
        "title": "Aceptado, y ahora lleva más tiempo",
        "body": "{{actor}} aceptó «{{job}}» y ahora necesita {{minutes}} minutos. Revisa la fecha de vencimiento."
      }
    },
    "quote_accepted": {
      "noJob": {
        "title": "Su presupuesto fue aceptado",
        "body": "Su presupuesto para una orden de trabajo fue aceptado. El trabajo es suyo."
      },
      "default": {
        "title": "Su presupuesto fue aceptado",
        "body": "Su presupuesto para «{{job}}» fue aceptado. El trabajo es suyo."
      }
    },
    "asset_request_job_assigned": {
      "noActor": {
        "title": "Trabajo asignado",
        "body": "El equipo asignó la orden de trabajo de {{request}} a {{assignee}}."
      },
      "default": {
        "title": "Trabajo asignado",
        "body": "{{actor}} asignó la orden de trabajo de {{request}} a {{assignee}}."
      }
    },
    "asset_request_job_accepted": {
      "noActor": {
        "title": "Orden de trabajo aceptada",
        "body": "El equipo aceptó la orden de trabajo de {{request}}."
      },
      "default": {
        "title": "Orden de trabajo aceptada",
        "body": "{{actor}} aceptó la orden de trabajo de {{request}}."
      }
    },
    "asset_request_job_declined": {
      "noActor": {
        "title": "Orden de trabajo rechazada",
        "body": "El equipo no puede asumir la orden de trabajo de {{request}}. El equipo buscará a otra persona."
      },
      "default": {
        "title": "Orden de trabajo rechazada",
        "body": "{{actor}} no puede asumir la orden de trabajo de {{request}}. El equipo buscará a otra persona."
      }
    },
    "asset_request_job_verified": {
      "noActor": {
        "title": "Trabajo verificado",
        "body": "El equipo verificó el trabajo realizado de {{request}}."
      },
      "default": {
        "title": "Trabajo verificado",
        "body": "{{actor}} verificó el trabajo realizado de {{request}}."
      }
    },
    "asset_request_inspection_approved": {
      "noActor": {
        "title": "Inspección aprobada",
        "body": "El equipo aprobó la inspección de {{request}}."
      },
      "default": {
        "title": "Inspección aprobada",
        "body": "{{actor}} aprobó la inspección de {{request}}."
      }
    },
    "asset_request_submitted": {
      "noActor": {
        "title": "Se creó una solicitud para usted",
        "body": "El equipo creó «{{request}}» para usted en {{asset}}."
      },
      "default": {
        "title": "Se creó una solicitud para usted",
        "body": "{{actor}} creó «{{request}}» para usted en {{asset}}."
      }
    },
    "job_started": {
      "noActor": {
        "title": "Orden de trabajo iniciada",
        "body": "La persona asignada inició «{{job}}»."
      },
      "default": {
        "title": "Orden de trabajo iniciada",
        "body": "{{actor}} inició «{{job}}»."
      }
    },
    "job_paused": {
      "noActorReason": {
        "title": "Orden de trabajo en pausa",
        "body": "La persona asignada pausó «{{job}}». {{reason}}"
      },
      "noActor": {
        "title": "Orden de trabajo en pausa",
        "body": "La persona asignada pausó «{{job}}»."
      },
      "reason": {
        "title": "Orden de trabajo en pausa",
        "body": "{{actor}} pausó «{{job}}». {{reason}}"
      },
      "default": {
        "title": "Orden de trabajo en pausa",
        "body": "{{actor}} pausó «{{job}}»."
      }
    },
    "job_resumed": {
      "noActor": {
        "title": "Orden de trabajo reanudada",
        "body": "La persona asignada reanudó «{{job}}»."
      },
      "default": {
        "title": "Orden de trabajo reanudada",
        "body": "{{actor}} reanudó «{{job}}»."
      }
    },
    "job_evidence_added": {
      "noActor": {
        "title": "Evidencias añadidas",
        "body": "La persona asignada añadió las evidencias que pidió en «{{job}}». Revíselas para cerrar la orden de trabajo."
      },
      "default": {
        "title": "Evidencias añadidas",
        "body": "{{actor}} añadió las evidencias que pidió en «{{job}}». Revíselas para cerrar la orden de trabajo."
      }
    },
    "inspection_cancelled": {
      "noActorNoAssetReason": {
        "title": "Inspección cancelada",
        "body": "Un compañero canceló la inspección de un activo. {{reason}}"
      },
      "noActorNoAsset": {
        "title": "Inspección cancelada",
        "body": "Un compañero canceló la inspección de un activo."
      },
      "noActorReason": {
        "title": "Inspección cancelada",
        "body": "Un compañero canceló la inspección de {{asset}}. {{reason}}"
      },
      "noActor": {
        "title": "Inspección cancelada",
        "body": "Un compañero canceló la inspección de {{asset}}."
      },
      "reason": {
        "title": "Inspección cancelada",
        "body": "{{actor}} canceló la inspección de {{asset}}. {{reason}}"
      },
      "default": {
        "title": "Inspección cancelada",
        "body": "{{actor}} canceló la inspección de {{asset}}."
      }
    },
    "asset_collaboration_shared": {
      "noAsset": {
        "title": "Se compartió un activo con usted",
        "body": "Activo: ábralo para revisar y aceptar el acceso."
      },
      "default": {
        "title": "Se compartió un activo con usted",
        "body": "{{asset}}: ábralo para revisar y aceptar el acceso."
      }
    },
    "asset_in_service": {
      "backNoAsset": {
        "title": "Activo de nuevo en servicio",
        "body": "Un activo está en servicio. Las programaciones se reanudan a partir de hoy. {{note}}"
      },
      "backNoAssetNoNote": {
        "title": "Activo de nuevo en servicio",
        "body": "Un activo está en servicio. Las programaciones se reanudan a partir de hoy."
      },
      "firstNoAsset": {
        "title": "Activo en servicio",
        "body": "Un activo está en servicio. Las programaciones se reanudan a partir de hoy. {{note}}"
      },
      "firstNoAssetNoNote": {
        "title": "Activo en servicio",
        "body": "Un activo está en servicio. Las programaciones se reanudan a partir de hoy."
      },
      "back": {
        "title": "Activo de nuevo en servicio",
        "body": "{{asset}} está en servicio. Las programaciones se reanudan a partir de hoy. {{note}}"
      },
      "backNoNote": {
        "title": "Activo de nuevo en servicio",
        "body": "{{asset}} está en servicio. Las programaciones se reanudan a partir de hoy."
      },
      "first": {
        "title": "Activo en servicio",
        "body": "{{asset}} está en servicio. Las programaciones se reanudan a partir de hoy. {{note}}"
      },
      "firstNoNote": {
        "title": "Activo en servicio",
        "body": "{{asset}} está en servicio. Las programaciones se reanudan a partir de hoy."
      }
    },
    "asset_out_of_service": {
      "noAsset": {
        "title": "Activo fuera de servicio",
        "body": "Un activo está fuera de servicio ({{reason}}). Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Activo fuera de servicio",
        "body": "Un activo está fuera de servicio ({{reason}}). Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio."
      },
      "noAssetNoReason": {
        "title": "Activo fuera de servicio",
        "body": "Un activo está fuera de servicio. Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "Activo fuera de servicio",
        "body": "Un activo está fuera de servicio. Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio."
      },
      "default": {
        "title": "Activo fuera de servicio",
        "body": "{{asset}} está fuera de servicio ({{reason}}). Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio. {{note}}"
      },
      "noNote": {
        "title": "Activo fuera de servicio",
        "body": "{{asset}} está fuera de servicio ({{reason}}). Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio."
      },
      "noReason": {
        "title": "Activo fuera de servicio",
        "body": "{{asset}} está fuera de servicio. Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio. {{note}}"
      },
      "noReasonNoNote": {
        "title": "Activo fuera de servicio",
        "body": "{{asset}} está fuera de servicio. Sus programaciones quedan en pausa hasta que se vuelva a poner en servicio."
      }
    },
    "asset_owner_assigned": {
      "default": {
        "title": "Nuevo activo a su cargo",
        "body": "{{asset}} está ahora a su cargo."
      }
    },
    "asset_owner_removed": {
      "default": {
        "title": "Cambio de responsable del activo",
        "body": "{{asset}} ya no está a su cargo."
      }
    },
    "asset_request_approved": {
      "noAsset": {
        "title": "Su solicitud se aprobó",
        "body": "Se aprobó «{{request}}» para el activo."
      },
      "default": {
        "title": "Su solicitud se aprobó",
        "body": "Se aprobó «{{request}}» para {{asset}}."
      },
      "withNote": {
        "title": "Su solicitud se aprobó",
        "body": "Se aprobó «{{request}}»: {{note}}"
      }
    },
    "asset_request_awaiting_customer": {
      "noAsset": {
        "title": "Su solicitud requiere una acción",
        "body": "{{request}} espera su respuesta para el activo."
      },
      "default": {
        "title": "Su solicitud requiere una acción",
        "body": "{{request}} espera su respuesta para {{asset}}."
      },
      "note": {
        "title": "Su solicitud requiere una acción",
        "body": "{{note}}"
      }
    },
    "asset_request_closed": {
      "byActor": {
        "title": "Caso cerrado: todo el trabajo está completado",
        "body": "{{actor}} verificó el último trabajo de {{request}}. Todo se completó y se aceptó."
      },
      "default": {
        "title": "Caso cerrado: todo el trabajo está completado",
        "body": "{{request}}: todo se completó y se aceptó. No queda nada por hacer."
      },
      "operatorClosed": {
        "title": "Su solicitud se cerró",
        "body": "La solicitud {{request}} se marcó como terminada."
      }
    },
    "asset_request_commented": {
      "requesterNoRequestPhotoLegacy": {
        "title": "Nuevo mensaje",
        "body": "El solicitante en una solicitud: compartió una foto."
      },
      "requesterNoRequestPhoto": {
        "title": "Nuevo mensaje",
        "body": "El solicitante en una solicitud: compartió una foto."
      },
      "teamNoRequestPhotoLegacy": {
        "title": "Nuevo mensaje",
        "body": "El equipo en una solicitud: compartió una foto."
      },
      "teamNoRequestPhoto": {
        "title": "Nuevo mensaje",
        "body": "El equipo en una solicitud: compartió una foto."
      },
      "requesterPhoto": {
        "title": "Nuevo mensaje",
        "body": "El solicitante en «{{request}}»: compartió una foto."
      },
      "noRequestPhotoLegacy": {
        "title": "Nuevo mensaje",
        "body": "{{author}} en una solicitud: compartió una foto."
      },
      "noRequestPhoto": {
        "title": "Nuevo mensaje",
        "body": "{{author}} en una solicitud: compartió una foto."
      },
      "teamPhoto": {
        "title": "Nuevo mensaje",
        "body": "El equipo en «{{request}}»: compartió una foto."
      },
      "requesterNoRequestLegacy": {
        "title": "Nuevo mensaje",
        "body": "El solicitante en una solicitud: {{message}}"
      },
      "requesterNoRequest": {
        "title": "Nuevo mensaje",
        "body": "El solicitante en una solicitud: {{message}}"
      },
      "teamNoRequestLegacy": {
        "title": "Nuevo mensaje",
        "body": "El equipo en una solicitud: {{message}}"
      },
      "teamNoRequest": {
        "title": "Nuevo mensaje",
        "body": "El equipo en una solicitud: {{message}}"
      },
      "photo": {
        "title": "Nuevo mensaje",
        "body": "{{author}} en «{{request}}»: compartió una foto."
      },
      "requester": {
        "title": "Nuevo mensaje",
        "body": "El solicitante en «{{request}}»: {{message}}"
      },
      "noRequestLegacy": {
        "title": "Nuevo mensaje",
        "body": "{{author}} en una solicitud: {{message}}"
      },
      "noRequest": {
        "title": "Nuevo mensaje",
        "body": "{{author}} en una solicitud: {{message}}"
      },
      "team": {
        "title": "Nuevo mensaje",
        "body": "El equipo en «{{request}}»: {{message}}"
      },
      "default": {
        "title": "Nuevo mensaje",
        "body": "{{author}} en «{{request}}»: {{message}}"
      }
    },
    "asset_request_completion_accepted": {
      "verifierNoRequesterNoRequestLegacy": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "El solicitante aceptó el trabajo completado de la solicitud. Verifique la orden de trabajo para cerrarla."
      },
      "verifierNoRequesterNoRequest": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "El solicitante aceptó el trabajo completado de la solicitud. Verifique la orden de trabajo para cerrarla."
      },
      "verifierNoRequester": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "El solicitante aceptó el trabajo completado de «{{request}}». Verifique la orden de trabajo para cerrarla."
      },
      "verifierNoRequestLegacy": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "{{requester}} aceptó el trabajo completado de la solicitud. Verifique la orden de trabajo para cerrarla."
      },
      "verifierNoRequest": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "{{requester}} aceptó el trabajo completado de la solicitud. Verifique la orden de trabajo para cerrarla."
      },
      "verifier": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "{{requester}} aceptó el trabajo completado de «{{request}}». Verifique la orden de trabajo para cerrarla."
      },
      "informedNoRequesterNoRequestLegacy": {
        "title": "El solicitante aceptó el trabajo",
        "body": "El solicitante aceptó el trabajo completado de la solicitud."
      },
      "informedNoRequesterNoRequest": {
        "title": "El solicitante aceptó el trabajo",
        "body": "El solicitante aceptó el trabajo completado de la solicitud."
      },
      "informedNoRequester": {
        "title": "El solicitante aceptó el trabajo",
        "body": "El solicitante aceptó el trabajo completado de «{{request}}»."
      },
      "informedNoRequestLegacy": {
        "title": "El solicitante aceptó el trabajo",
        "body": "{{requester}} aceptó el trabajo completado de la solicitud."
      },
      "informedNoRequest": {
        "title": "El solicitante aceptó el trabajo",
        "body": "{{requester}} aceptó el trabajo completado de la solicitud."
      },
      "informed": {
        "title": "El solicitante aceptó el trabajo",
        "body": "{{requester}} aceptó el trabajo completado de «{{request}}»."
      }
    },
    "asset_request_completion_rejected": {
      "noActor": {
        "title": "Finalización rechazada",
        "body": "El equipo rechazó el trabajo completado de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Finalización rechazada",
        "body": "El equipo rechazó el trabajo completado de {{request}}."
      },
      "default": {
        "title": "Finalización rechazada",
        "body": "{{actor}} rechazó el trabajo completado de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Finalización rechazada",
        "body": "{{actor}} rechazó el trabajo completado de {{request}}."
      }
    },
    "asset_request_confirmed_schedule": {
      "requestNoRequest": {
        "title": "Fecha confirmada",
        "body": "Solicitud: el solicitante confirmó la visita programada."
      },
      "visitNoInspection": {
        "title": "Visita confirmada",
        "body": "Se confirmó la visita de la inspección del {{when}}."
      },
      "request": {
        "title": "Fecha confirmada",
        "body": "{{request}}: el solicitante confirmó la visita programada."
      },
      "visitNoJob": {
        "title": "Visita confirmada",
        "body": "Se confirmó la visita de la orden de trabajo del {{when}}."
      },
      "visit": {
        "title": "Visita confirmada",
        "body": "Se confirmó la visita de {{work}} del {{when}}."
      }
    },
    "asset_request_converted": {
      "toInspection": {
        "title": "Su solicitud se convirtió en una inspección",
        "body": "Se programó {{request}} como trabajo operativo."
      },
      "toJob": {
        "title": "Su solicitud se convirtió en una orden de trabajo",
        "body": "{{request}} ya está en la cola de trabajo."
      },
      "inspectionUndated": {
        "title": "Inspección programada",
        "body": "Se programó una inspección para {{request}}."
      },
      "jobDue": {
        "title": "Su solicitud ahora es una orden de trabajo",
        "body": "{{request}} ahora es una orden de trabajo para {{assignee}}, con vencimiento el {{dueDate}}."
      },
      "inspectionScheduled": {
        "title": "Inspección programada",
        "body": "{{request}}: inspección programada para el {{scheduledWhen}}."
      },
      "jobDueNoAssignee": {
        "title": "Su solicitud ahora es una orden de trabajo",
        "body": "{{request}} ahora es una orden de trabajo, con vencimiento el {{dueDate}}."
      },
      "job": {
        "title": "Su solicitud ahora es una orden de trabajo",
        "body": "{{request}} ahora es una orden de trabajo para {{assignee}}."
      },
      "jobScheduled": {
        "title": "Orden de trabajo programada",
        "body": "{{request}}: orden de trabajo para {{assignee}} programada para el {{scheduledDate}}."
      },
      "jobNoAssignee": {
        "title": "Su solicitud ahora es una orden de trabajo",
        "body": "{{request}} ahora es una orden de trabajo."
      },
      "jobScheduledNoAssignee": {
        "title": "Orden de trabajo programada",
        "body": "{{request}}: orden de trabajo programada para el {{scheduledDate}}."
      }
    },
    "asset_request_created": {
      "noAssetOperatorNoRequestPublicLinkLegacy": {
        "title": "Nueva solicitud para un activo",
        "body": "Un operador envió una solicitud a través del enlace público."
      },
      "noAssetOperatorNoRequestPublicLink": {
        "title": "Nueva solicitud para un activo",
        "body": "Un operador envió una solicitud a través del enlace público."
      },
      "noAssetContactNoRequestPublicLinkLegacy": {
        "title": "Nueva solicitud para un activo",
        "body": "Un contacto envió una solicitud a través del enlace público."
      },
      "noAssetContactNoRequestPublicLink": {
        "title": "Nueva solicitud para un activo",
        "body": "Un contacto envió una solicitud a través del enlace público."
      },
      "operatorNoRequestPublicLinkLegacy": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un operador envió una solicitud a través del enlace público."
      },
      "operatorNoRequestPublicLink": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un operador envió una solicitud a través del enlace público."
      },
      "contactNoRequestPublicLinkLegacy": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un contacto envió una solicitud a través del enlace público."
      },
      "contactNoRequestPublicLink": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un contacto envió una solicitud a través del enlace público."
      },
      "noAssetOperatorPublicLink": {
        "title": "Nueva solicitud para un activo",
        "body": "Un operador envió «{{request}}» a través del enlace público."
      },
      "noAssetNoRequestPublicLinkLegacy": {
        "title": "Nueva solicitud para un activo",
        "body": "{{submitter}} envió una solicitud a través del enlace público."
      },
      "noAssetNoRequestPublicLink": {
        "title": "Nueva solicitud para un activo",
        "body": "{{submitter}} envió una solicitud a través del enlace público."
      },
      "noAssetContactPublicLink": {
        "title": "Nueva solicitud para un activo",
        "body": "Un contacto envió «{{request}}» a través del enlace público."
      },
      "operatorPublicLink": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un operador envió «{{request}}» a través del enlace público."
      },
      "noRequestPublicLinkLegacy": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "{{submitter}} envió una solicitud a través del enlace público."
      },
      "noRequestPublicLink": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "{{submitter}} envió una solicitud a través del enlace público."
      },
      "contactPublicLink": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un contacto envió «{{request}}» a través del enlace público."
      },
      "noAssetPublicLink": {
        "title": "Nueva solicitud para un activo",
        "body": "{{submitter}} envió «{{request}}» a través del enlace público."
      },
      "noAssetOperatorNoRequestLegacy": {
        "title": "Nueva solicitud para un activo",
        "body": "Un operador envió una solicitud."
      },
      "noAssetOperatorNoRequest": {
        "title": "Nueva solicitud para un activo",
        "body": "Un operador envió una solicitud."
      },
      "noAssetContactNoRequestLegacy": {
        "title": "Nueva solicitud para un activo",
        "body": "Un contacto envió una solicitud."
      },
      "noAssetContactNoRequest": {
        "title": "Nueva solicitud para un activo",
        "body": "Un contacto envió una solicitud."
      },
      "publicLink": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "{{submitter}} envió «{{request}}» a través del enlace público."
      },
      "operatorNoRequestLegacy": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un operador envió una solicitud."
      },
      "operatorNoRequest": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un operador envió una solicitud."
      },
      "contactNoRequestLegacy": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un contacto envió una solicitud."
      },
      "contactNoRequest": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un contacto envió una solicitud."
      },
      "noAssetOperator": {
        "title": "Nueva solicitud para un activo",
        "body": "Un operador envió «{{request}}»."
      },
      "noAssetNoRequestLegacy": {
        "title": "Nueva solicitud para un activo",
        "body": "{{submitter}} envió una solicitud."
      },
      "noAssetNoRequest": {
        "title": "Nueva solicitud para un activo",
        "body": "{{submitter}} envió una solicitud."
      },
      "noAssetContact": {
        "title": "Nueva solicitud para un activo",
        "body": "Un contacto envió «{{request}}»."
      },
      "operator": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un operador envió «{{request}}»."
      },
      "noRequestLegacy": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "{{submitter}} envió una solicitud."
      },
      "noRequest": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "{{submitter}} envió una solicitud."
      },
      "contact": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "Un contacto envió «{{request}}»."
      },
      "noAsset": {
        "title": "Nueva solicitud para un activo",
        "body": "{{submitter}} envió «{{request}}»."
      },
      "default": {
        "title": "Nueva solicitud para {{asset}}",
        "body": "{{submitter}} envió «{{request}}»."
      }
    },
    "asset_request_evidence_requested": {
      "noAsset": {
        "title": "Solicitud actualizada",
        "body": "Se actualizó {{request}} para el activo. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Solicitud actualizada",
        "body": "Se actualizó {{request}} para el activo."
      },
      "default": {
        "title": "Solicitud actualizada",
        "body": "Se actualizó {{request}} para {{asset}}. {{note}}"
      },
      "noNote": {
        "title": "Solicitud actualizada",
        "body": "Se actualizó {{request}} para {{asset}}."
      }
    },
    "asset_request_inspection_cancelled": {
      "noActor": {
        "title": "Inspección cancelada",
        "body": "El equipo canceló la inspección de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspección cancelada",
        "body": "El equipo canceló la inspección de {{request}}."
      },
      "default": {
        "title": "Inspección cancelada",
        "body": "{{actor}} canceló la inspección de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspección cancelada",
        "body": "{{actor}} canceló la inspección de {{request}}."
      }
    },
    "asset_request_inspection_completed": {
      "noActor": {
        "title": "Inspección completada",
        "body": "El equipo completó la inspección de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspección completada",
        "body": "El equipo completó la inspección de {{request}}."
      },
      "default": {
        "title": "Inspección completada",
        "body": "{{actor}} completó la inspección de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspección completada",
        "body": "{{actor}} completó la inspección de {{request}}."
      }
    },
    "asset_request_inspection_paused": {
      "noActor": {
        "title": "Inspección en pausa",
        "body": "El equipo pausó la inspección de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspección en pausa",
        "body": "El equipo pausó la inspección de {{request}}."
      },
      "default": {
        "title": "Inspección en pausa",
        "body": "{{actor}} pausó la inspección de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspección en pausa",
        "body": "{{actor}} pausó la inspección de {{request}}."
      }
    },
    "asset_request_inspection_reassigned": {
      "toAssigneeNoActor": {
        "title": "Inspección reasignada",
        "body": "El equipo reasignó la inspección de {{request}} a {{assignee}}."
      },
      "noActor": {
        "title": "Inspección reasignada",
        "body": "El equipo reasignó la inspección de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspección reasignada",
        "body": "El equipo reasignó la inspección de {{request}}."
      },
      "toAssignee": {
        "title": "Inspección reasignada",
        "body": "{{actor}} reasignó la inspección de {{request}} a {{assignee}}."
      },
      "default": {
        "title": "Inspección reasignada",
        "body": "{{actor}} reasignó la inspección de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspección reasignada",
        "body": "{{actor}} reasignó la inspección de {{request}}."
      }
    },
    "asset_request_inspection_resumed": {
      "noActorReopened": {
        "title": "Inspección reanudada",
        "body": "El equipo reanudó la inspección de {{request}}. Inspección reabierta."
      },
      "reopened": {
        "title": "Inspección reanudada",
        "body": "{{actor}} reanudó la inspección de {{request}}. Inspección reabierta."
      },
      "noActor": {
        "title": "Inspección reanudada",
        "body": "El equipo reanudó la inspección de {{request}}."
      },
      "default": {
        "title": "Inspección reanudada",
        "body": "{{actor}} reanudó la inspección de {{request}}."
      }
    },
    "asset_request_inspection_started": {
      "noActor": {
        "title": "Inspección iniciada",
        "body": "El equipo inició la inspección de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspección iniciada",
        "body": "El equipo inició la inspección de {{request}}."
      },
      "default": {
        "title": "Inspección iniciada",
        "body": "{{actor}} inició la inspección de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspección iniciada",
        "body": "{{actor}} inició la inspección de {{request}}."
      }
    },
    "asset_request_job_cancelled": {
      "noActor": {
        "title": "Orden de trabajo cancelada",
        "body": "El equipo canceló la orden de trabajo de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Orden de trabajo cancelada",
        "body": "El equipo canceló la orden de trabajo de {{request}}."
      },
      "default": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló la orden de trabajo de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló la orden de trabajo de {{request}}."
      }
    },
    "asset_request_job_completed": {
      "noActorNoJobLegacy": {
        "title": "Orden de trabajo completada",
        "body": "El equipo completó la orden de trabajo de su solicitud. Revise el trabajo y confirme la solución."
      },
      "noActorNoJob": {
        "title": "Orden de trabajo completada",
        "body": "El equipo completó la orden de trabajo de su solicitud. Revise el trabajo y confirme la solución."
      },
      "noJobLegacy": {
        "title": "Orden de trabajo completada",
        "body": "{{actor}} completó la orden de trabajo de su solicitud. Revise el trabajo y confirme la solución."
      },
      "noJob": {
        "title": "Orden de trabajo completada",
        "body": "{{actor}} completó la orden de trabajo de su solicitud. Revise el trabajo y confirme la solución."
      },
      "noActor": {
        "title": "Orden de trabajo completada",
        "body": "El equipo completó la orden de trabajo «{{job}}». Revise el trabajo y confirme la solución."
      },
      "default": {
        "title": "Orden de trabajo completada",
        "body": "{{actor}} completó la orden de trabajo «{{job}}». Revise el trabajo y confirme la solución."
      }
    },
    "asset_request_job_created": {
      "noActorOutsideRepairsLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo creó una orden de trabajo para {{request}} fuera de las reparaciones aprobadas: «{{job}}»."
      },
      "outsideRepairsLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} creó una orden de trabajo para {{request}} fuera de las reparaciones aprobadas: «{{job}}»."
      },
      "noActorLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo creó una orden de trabajo para {{request}}: «{{job}}»."
      },
      "noActorFromRepairLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo creó una orden de trabajo para {{request}} a partir de una reparación aprobada: «{{job}}»."
      },
      "noActorFollowUpLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo propuso una orden de trabajo de seguimiento para {{request}}: «{{job}}»."
      },
      "defaultLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} creó una orden de trabajo para {{request}}: «{{job}}»."
      },
      "fromRepairLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} creó una orden de trabajo para {{request}} a partir de una reparación aprobada: «{{job}}»."
      },
      "followUpLegacy": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} propuso una orden de trabajo de seguimiento para {{request}}: «{{job}}»."
      },
      "noActorOutsideRepairs": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo creó una orden de trabajo para {{request}} fuera de las reparaciones aprobadas: «{{job}}»."
      },
      "noActorFromRepair": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo creó una orden de trabajo para {{request}} a partir de una reparación aprobada: «{{job}}»."
      },
      "noActorFollowUp": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo propuso una orden de trabajo de seguimiento para {{request}}: «{{job}}»."
      },
      "noActor": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "El equipo creó una orden de trabajo para {{request}}: «{{job}}»."
      },
      "outsideRepairs": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} creó una orden de trabajo para {{request}} fuera de las reparaciones aprobadas: «{{job}}»."
      },
      "fromRepair": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} creó una orden de trabajo para {{request}} a partir de una reparación aprobada: «{{job}}»."
      },
      "followUp": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} propuso una orden de trabajo de seguimiento para {{request}}: «{{job}}»."
      },
      "default": {
        "title": "Orden de trabajo creada a partir de la solicitud",
        "body": "{{actor}} creó una orden de trabajo para {{request}}: «{{job}}»."
      }
    },
    "asset_request_job_paused": {
      "noActor": {
        "title": "Trabajo en pausa",
        "body": "El equipo pausó la orden de trabajo de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Trabajo en pausa",
        "body": "El equipo pausó la orden de trabajo de {{request}}."
      },
      "default": {
        "title": "Trabajo en pausa",
        "body": "{{actor}} pausó la orden de trabajo de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Trabajo en pausa",
        "body": "{{actor}} pausó la orden de trabajo de {{request}}."
      }
    },
    "asset_request_job_resumed": {
      "noActor": {
        "title": "Trabajo reanudado",
        "body": "El equipo reanudó la orden de trabajo de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Trabajo reanudado",
        "body": "El equipo reanudó la orden de trabajo de {{request}}."
      },
      "default": {
        "title": "Trabajo reanudado",
        "body": "{{actor}} reanudó la orden de trabajo de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Trabajo reanudado",
        "body": "{{actor}} reanudó la orden de trabajo de {{request}}."
      }
    },
    "asset_request_job_started": {
      "noActor": {
        "title": "Orden de trabajo iniciada",
        "body": "El equipo inició la orden de trabajo de {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Orden de trabajo iniciada",
        "body": "El equipo inició la orden de trabajo de {{request}}."
      },
      "default": {
        "title": "Orden de trabajo iniciada",
        "body": "{{actor}} inició la orden de trabajo de {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Orden de trabajo iniciada",
        "body": "{{actor}} inició la orden de trabajo de {{request}}."
      }
    },
    "asset_request_rejected": {
      "withNote": {
        "title": "Su solicitud se rechazó",
        "body": "Se rechazó «{{request}}»: {{note}}"
      },
      "default": {
        "title": "Su solicitud se rechazó",
        "body": "Se rechazó «{{request}}»."
      }
    },
    "asset_request_report_shared": {
      "forYouLegacy": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para su revisión: {{findingCount}} hallazgo(s) que atender."
      },
      "defaultLegacy": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para revisión: {{findingCount}} hallazgo(s) con reparación sugerida."
      },
      "forYouPlainLegacy": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para su revisión."
      },
      "plainLegacy": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para revisión."
      },
      "forYou": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para su revisión: {{findingCount}} hallazgo(s) que atender."
      },
      "default": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para revisión: {{findingCount}} hallazgo(s) con reparación sugerida."
      },
      "forYouPlain": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para su revisión."
      },
      "plain": {
        "title": "Informe de inspección compartido",
        "body": "El informe de {{request}} está listo para revisión."
      }
    },
    "asset_request_requested_reschedule": {
      "visitNoInspectionNoPreference": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. No se indicó un horario preferido."
      },
      "visitNoJobNoPreference": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. No se indicó un horario preferido."
      },
      "visitNoInspection": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. Prefiere el {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionNoNote": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. Prefiere el {{preferredDate}} · {{period}}"
      },
      "visitNoInspectionNoPeriod": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. Prefiere el {{preferredDate}} · {{note}}"
      },
      "visitNoPreference": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. No se indicó un horario preferido."
      },
      "visitNoInspectionDateOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. Prefiere el {{preferredDate}}"
      },
      "visitNoJob": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. Prefiere el {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoJobNoNote": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. Prefiere el {{preferredDate}} · {{period}}"
      },
      "visitNoJobNoPeriod": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. Prefiere el {{preferredDate}} · {{note}}"
      },
      "visitNoInspectionNoDate": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. Preferencia: {{period}} · {{note}}"
      },
      "visitNoJobDateOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. Prefiere el {{preferredDate}}"
      },
      "visit": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. Prefiere el {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionPeriodOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. Preferencia: {{period}}"
      },
      "visitNoInspectionNoteOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la inspección. {{note}}"
      },
      "visitNoNote": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. Prefiere el {{preferredDate}} · {{period}}"
      },
      "visitNoPeriod": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. Prefiere el {{preferredDate}} · {{note}}"
      },
      "visitNoJobNoDate": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. Preferencia: {{period}} · {{note}}"
      },
      "requestNoRequest": {
        "title": "Se solicitó otro horario",
        "body": "Solicitud: el solicitante pidió otro horario. ({{preferredDate}}, {{periodLabel}})"
      },
      "requestNoRequestNoPeriod": {
        "title": "Se solicitó otro horario",
        "body": "Solicitud: el solicitante pidió otro horario. ({{preferredDate}})"
      },
      "visitDateOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. Prefiere el {{preferredDate}}"
      },
      "visitNoJobPeriodOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. Preferencia: {{period}}"
      },
      "visitNoJobNoteOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para la orden de trabajo. {{note}}"
      },
      "requestNoRequestNoPreference": {
        "title": "Se solicitó otro horario",
        "body": "Solicitud: el solicitante pidió otro horario."
      },
      "visitNoDate": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. Preferencia: {{period}} · {{note}}"
      },
      "request": {
        "title": "Se solicitó otro horario",
        "body": "{{request}}: el solicitante pidió otro horario. ({{preferredDate}}, {{periodLabel}})"
      },
      "requestNoPeriod": {
        "title": "Se solicitó otro horario",
        "body": "{{request}}: el solicitante pidió otro horario. ({{preferredDate}})"
      },
      "visitPeriodOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. Preferencia: {{period}}"
      },
      "visitNoteOnly": {
        "title": "Se solicitó otro horario de visita",
        "body": "Se pidió otro horario para {{work}}. {{note}}"
      },
      "requestNoPreference": {
        "title": "Se solicitó otro horario",
        "body": "{{request}}: el solicitante pidió otro horario."
      }
    },
    "asset_request_requester_cancelled": {
      "noRequest": {
        "title": "Solicitud retirada",
        "body": "El solicitante retiró la solicitud. {{reason}}"
      },
      "noRequestNoReason": {
        "title": "Solicitud retirada",
        "body": "El solicitante retiró la solicitud."
      },
      "default": {
        "title": "Solicitud retirada",
        "body": "El solicitante retiró {{request}}. {{reason}}"
      },
      "noReason": {
        "title": "Solicitud retirada",
        "body": "El solicitante retiró {{request}}."
      }
    },
    "asset_request_response_received": {
      "approvedLegacy": {
        "title": "Respuesta al informe recibida",
        "body": "El informe de {{request}} fue aprobado."
      },
      "rejectedLegacy": {
        "title": "Respuesta al informe recibida",
        "body": "El informe de {{request}} fue rechazado."
      },
      "defaultLegacy": {
        "title": "Respuesta al informe recibida",
        "body": "El informe de {{request}} fue rechazado. {{reason}}"
      },
      "approved": {
        "title": "Respuesta al informe recibida",
        "body": "El informe de {{request}} fue aprobado."
      },
      "rejected": {
        "title": "Respuesta al informe recibida",
        "body": "El informe de {{request}} fue rechazado."
      },
      "default": {
        "title": "Respuesta al informe recibida",
        "body": "El informe de {{request}} fue rechazado. {{reason}}"
      }
    },
    "asset_request_rework_requested": {
      "requesterNoRequesterNoRequestNoReasonLegacy": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en la solicitud."
      },
      "requesterNoRequesterNoReasonLegacy": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en «{{request}}»."
      },
      "requesterNoRequestNoReasonLegacy": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en la solicitud."
      },
      "requesterNoReasonLegacy": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en «{{request}}»."
      },
      "requesterNoRequesterNoRequestLegacy": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en la solicitud: {{reason}}"
      },
      "requesterNoRequestLegacy": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en la solicitud: {{reason}}"
      },
      "requesterNoRequesterNoRequestNoReason": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en la solicitud."
      },
      "requesterNoRequesterNoReason": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en «{{request}}»."
      },
      "requesterNoRequestNoReason": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en la solicitud."
      },
      "requesterNoReason": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en «{{request}}»."
      },
      "requesterNoRequesterNoRequest": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en la solicitud: {{reason}}"
      },
      "requesterNoRequester": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en «{{request}}»: {{reason}}"
      },
      "requesterNoRequest": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en la solicitud: {{reason}}"
      },
      "teamNoActor": {
        "title": "Retrabajo solicitado",
        "body": "El equipo pidió un retrabajo en {{request}}. {{note}}"
      },
      "teamNoActorNoNote": {
        "title": "Retrabajo solicitado",
        "body": "El equipo pidió un retrabajo en {{request}}."
      },
      "requester": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en «{{request}}»: {{reason}}"
      },
      "team": {
        "title": "Retrabajo solicitado",
        "body": "{{actor}} pidió un retrabajo en {{request}}. {{note}}"
      },
      "teamNoNote": {
        "title": "Retrabajo solicitado",
        "body": "{{actor}} pidió un retrabajo en {{request}}."
      }
    },
    "asset_request_scheduled": {
      "scheduled": {
        "title": "Su solicitud se programó",
        "body": "Se programó {{request}} para el {{scheduledDate}}."
      },
      "rescheduled": {
        "title": "Su visita se reprogramó",
        "body": "{{request}}: nueva fecha, {{newWhen}}."
      }
    },
    "asset_retired": {
      "noAsset": {
        "title": "Activo retirado definitivamente",
        "body": "Un activo se retiró definitivamente ({{reason}}). Ya no admite nuevas inspecciones ni órdenes de trabajo. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Activo retirado definitivamente",
        "body": "Un activo se retiró definitivamente ({{reason}}). Ya no admite nuevas inspecciones ni órdenes de trabajo."
      },
      "noAssetNoReason": {
        "title": "Activo retirado definitivamente",
        "body": "Un activo se retiró definitivamente. Ya no admite nuevas inspecciones ni órdenes de trabajo. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "Activo retirado definitivamente",
        "body": "Un activo se retiró definitivamente. Ya no admite nuevas inspecciones ni órdenes de trabajo."
      },
      "default": {
        "title": "Activo retirado definitivamente",
        "body": "{{asset}} se retiró definitivamente ({{reason}}). Ya no admite nuevas inspecciones ni órdenes de trabajo. {{note}}"
      },
      "noNote": {
        "title": "Activo retirado definitivamente",
        "body": "{{asset}} se retiró definitivamente ({{reason}}). Ya no admite nuevas inspecciones ni órdenes de trabajo."
      },
      "noReason": {
        "title": "Activo retirado definitivamente",
        "body": "{{asset}} se retiró definitivamente. Ya no admite nuevas inspecciones ni órdenes de trabajo. {{note}}"
      },
      "noReasonNoNote": {
        "title": "Activo retirado definitivamente",
        "body": "{{asset}} se retiró definitivamente. Ya no admite nuevas inspecciones ni órdenes de trabajo."
      }
    },
    "asset_share_accepted": {
      "noContactNoAsset": {
        "title": "Acceso compartido al activo aceptado",
        "body": "Un contacto aceptó el acceso al activo."
      },
      "noAsset": {
        "title": "Acceso compartido al activo aceptado",
        "body": "{{contact}} aceptó el acceso al activo."
      },
      "noContact": {
        "title": "Acceso compartido al activo aceptado",
        "body": "Un contacto aceptó el acceso a {{asset}}."
      },
      "default": {
        "title": "Acceso compartido al activo aceptado",
        "body": "{{contact}} aceptó el acceso a {{asset}}."
      }
    },
    "asset_share_declined": {
      "noContactNoAsset": {
        "title": "Acceso compartido al activo rechazado",
        "body": "Un contacto rechazó el acceso al activo."
      },
      "noAsset": {
        "title": "Acceso compartido al activo rechazado",
        "body": "{{contact}} rechazó el acceso al activo."
      },
      "noContact": {
        "title": "Acceso compartido al activo rechazado",
        "body": "Un contacto rechazó el acceso a {{asset}}."
      },
      "default": {
        "title": "Acceso compartido al activo rechazado",
        "body": "{{contact}} rechazó el acceso a {{asset}}."
      }
    },
    "asset_share_ended": {
      "noAsset": {
        "title": "Activo compartido retirado definitivamente",
        "body": "El propietario de un activo lo retiró definitivamente, así que su acceso a él ha terminado. Lo que usted haya notificado sobre él se conserva en el registro del propietario."
      },
      "default": {
        "title": "Activo compartido retirado definitivamente",
        "body": "El propietario de {{asset}} lo retiró definitivamente, así que su acceso a él ha terminado. Lo que usted haya notificado sobre él se conserva en el registro del propietario."
      }
    },
    "asset_team_assigned": {
      "noTeam": {
        "title": "Nuevo activo en su equipo",
        "body": "{{asset}} se asignó a su equipo."
      },
      "default": {
        "title": "Nuevo activo en su equipo",
        "body": "{{asset}} se asignó a {{team}}."
      }
    },
    "asset_team_removed": {
      "default": {
        "title": "Activo trasladado fuera de su equipo",
        "body": "{{asset}} ya no está asignado a su equipo."
      }
    },
    "automation_notice": {
      "default": {
        "title": "{{title}}",
        "body": "{{body}}"
      }
    },
    "completion_submitted": {
      "requesterFirstNoActorNoJobNoRequesterLegacy": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "Un compañero completó una orden de trabajo. Primero el solicitante confirma la solución; después usted la verifica."
      },
      "requesterFirstNoActorNoJobNoRequester": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "Un compañero completó una orden de trabajo. Primero el solicitante confirma la solución; después usted la verifica."
      },
      "requesterFirstNoActorNoRequester": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "Un compañero completó «{{job}}». Primero el solicitante confirma la solución; después usted la verifica."
      },
      "requesterFirstNoJobNoRequesterLegacy": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "{{actor}} completó una orden de trabajo. Primero el solicitante confirma la solución; después usted la verifica."
      },
      "requesterFirstNoJobNoRequester": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "{{actor}} completó una orden de trabajo. Primero el solicitante confirma la solución; después usted la verifica."
      },
      "requesterFirstNoActorNoJobLegacy": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "Un compañero completó una orden de trabajo. Primero {{requester}} confirma la solución; después usted la verifica."
      },
      "requesterFirstNoActorNoJob": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "Un compañero completó una orden de trabajo. Primero {{requester}} confirma la solución; después usted la verifica."
      },
      "requesterFirstNoRequester": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "{{actor}} completó «{{job}}». Primero el solicitante confirma la solución; después usted la verifica."
      },
      "requesterFirstNoActor": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "Un compañero completó «{{job}}». Primero {{requester}} confirma la solución; después usted la verifica."
      },
      "requesterFirstNoJobLegacy": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "{{actor}} completó una orden de trabajo. Primero {{requester}} confirma la solución; después usted la verifica."
      },
      "requesterFirstNoJob": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "{{actor}} completó una orden de trabajo. Primero {{requester}} confirma la solución; después usted la verifica."
      },
      "requesterFirst": {
        "title": "Orden de trabajo completada: primero confirma el solicitante",
        "body": "{{actor}} completó «{{job}}». Primero {{requester}} confirma la solución; después usted la verifica."
      },
      "forApprovalSelf": {
        "title": "Su finalización está lista para verificar",
        "body": "Ha completado «{{job}}». Verifíquela para cerrar el trabajo."
      },
      "forApprovalSelfNoJob": {
        "title": "Su finalización está lista para verificar",
        "body": "Ha completado un trabajo. Verifíquelo para cerrarlo."
      },
      "forApprovalNoActorNoJobLegacy": {
        "title": "Finalización de la orden de trabajo enviada para aprobación",
        "body": "Un compañero completó una orden de trabajo. Revísela y apruébela."
      },
      "forApprovalNoActorNoJob": {
        "title": "Finalización de la orden de trabajo enviada para aprobación",
        "body": "Un compañero completó una orden de trabajo. Revísela y apruébela."
      },
      "forApprovalNoActor": {
        "title": "Finalización de la orden de trabajo enviada para aprobación",
        "body": "Un compañero completó «{{job}}». Revísela y apruébela."
      },
      "forApprovalNoJobLegacy": {
        "title": "Finalización de la orden de trabajo enviada para aprobación",
        "body": "{{actor}} completó una orden de trabajo. Revísela y apruébela."
      },
      "forApprovalNoJob": {
        "title": "Finalización de la orden de trabajo enviada para aprobación",
        "body": "{{actor}} completó una orden de trabajo. Revísela y apruébela."
      },
      "forApproval": {
        "title": "Finalización de la orden de trabajo enviada para aprobación",
        "body": "{{actor}} completó «{{job}}». Revísela y apruébela."
      }
    },
    "document_expiring": {
      "certificateNoDocument": {
        "title": "Certificado que caduca pronto",
        "body": "Un documento · {{asset}} caduca el {{expiryDate}}."
      },
      "certificateNoDocumentNoAsset": {
        "title": "Certificado que caduca pronto",
        "body": "Un documento caduca el {{expiryDate}}."
      },
      "documentNoDocument": {
        "title": "Documento que caduca pronto",
        "body": "Un documento · {{asset}} caduca el {{expiryDate}}."
      },
      "documentNoDocumentNoAsset": {
        "title": "Documento que caduca pronto",
        "body": "Un documento caduca el {{expiryDate}}."
      },
      "certificate": {
        "title": "Certificado que caduca pronto",
        "body": "{{document}} · {{asset}} caduca el {{expiryDate}}."
      },
      "certificateNoAsset": {
        "title": "Certificado que caduca pronto",
        "body": "{{document}} caduca el {{expiryDate}}."
      },
      "document": {
        "title": "Documento que caduca pronto",
        "body": "{{document}} · {{asset}} caduca el {{expiryDate}}."
      },
      "documentNoAsset": {
        "title": "Documento que caduca pronto",
        "body": "{{document}} caduca el {{expiryDate}}."
      }
    },
    "document_rejected": {
      "noValidatorNoAsset": {
        "title": "Documento rechazado",
        "body": "El validador rechazó «{{document}}» de un activo. Motivo: {{reason}}"
      },
      "noValidator": {
        "title": "Documento rechazado",
        "body": "El validador rechazó «{{document}}» de {{asset}}. Motivo: {{reason}}"
      },
      "noValidatorNoAssetNoReason": {
        "title": "Documento rechazado",
        "body": "El validador rechazó «{{document}}» de un activo."
      },
      "noAsset": {
        "title": "Documento rechazado",
        "body": "{{validator}} rechazó «{{document}}» de un activo. Motivo: {{reason}}"
      },
      "noValidatorNoReason": {
        "title": "Documento rechazado",
        "body": "El validador rechazó «{{document}}» de {{asset}}."
      },
      "default": {
        "title": "Documento rechazado",
        "body": "{{validator}} rechazó «{{document}}» de {{asset}}. Motivo: {{reason}}"
      },
      "noAssetNoReason": {
        "title": "Documento rechazado",
        "body": "{{validator}} rechazó «{{document}}» de un activo."
      },
      "noReason": {
        "title": "Documento rechazado",
        "body": "{{validator}} rechazó «{{document}}» de {{asset}}."
      }
    },
    "document_validated": {
      "noValidatorNoAsset": {
        "title": "Documento validado",
        "body": "El validador validó «{{document}}» de un activo."
      },
      "noValidator": {
        "title": "Documento validado",
        "body": "El validador validó «{{document}}» de {{asset}}."
      },
      "noAsset": {
        "title": "Documento validado",
        "body": "{{validator}} validó «{{document}}» de un activo."
      },
      "default": {
        "title": "Documento validado",
        "body": "{{validator}} validó «{{document}}» de {{asset}}."
      }
    },
    "document_validation_requested": {
      "reminderNoRequesterNoAsset": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "Un compañero le recordó que valide {{documentType}} de un activo (caduca el {{expiryDate}})."
      },
      "reminderNoRequester": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "Un compañero le recordó que valide {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "reminderNoAsset": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "{{requester}} le recordó que valide {{documentType}} de un activo (caduca el {{expiryDate}})."
      },
      "reminderNoRequesterNoAssetNoExpiry": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "Un compañero le recordó que valide {{documentType}} de un activo."
      },
      "requestNoRequesterNoAsset": {
        "title": "Valide «{{document}}»",
        "body": "Un compañero le pidió que valide {{documentType}} de un activo (caduca el {{expiryDate}})."
      },
      "reminder": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "{{requester}} le recordó que valide {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "reminderNoRequesterNoExpiry": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "Un compañero le recordó que valide {{documentType}} de {{asset}}."
      },
      "requestNoRequester": {
        "title": "Valide «{{document}}»",
        "body": "Un compañero le pidió que valide {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "reminderNoAssetNoExpiry": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "{{requester}} le recordó que valide {{documentType}} de un activo."
      },
      "requestNoAsset": {
        "title": "Valide «{{document}}»",
        "body": "{{requester}} le pidió que valide {{documentType}} de un activo (caduca el {{expiryDate}})."
      },
      "requestNoRequesterNoAssetNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "Un compañero le pidió que valide {{documentType}} de un activo."
      },
      "reminderNoExpiry": {
        "title": "Recordatorio: valide «{{document}}»",
        "body": "{{requester}} le recordó que valide {{documentType}} de {{asset}}."
      },
      "request": {
        "title": "Valide «{{document}}»",
        "body": "{{requester}} le pidió que valide {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "requestNoRequesterNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "Un compañero le pidió que valide {{documentType}} de {{asset}}."
      },
      "requestNoAssetNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "{{requester}} le pidió que valide {{documentType}} de un activo."
      },
      "requestNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "{{requester}} le pidió que valide {{documentType}} de {{asset}}."
      },
      "uploadedByYou": {
        "title": "Valide «{{document}}»",
        "body": "Usted subió {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "uploadedByColleague": {
        "title": "Valide «{{document}}»",
        "body": "Un compañero subió {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "uploaded": {
        "title": "Valide «{{document}}»",
        "body": "{{uploader}} subió {{documentType}} de {{asset}} (caduca el {{expiryDate}})."
      },
      "uploadedByYouNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "Usted subió {{documentType}} de {{asset}}."
      },
      "uploadedByColleagueNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "Un compañero subió {{documentType}} de {{asset}}."
      },
      "uploadedNoExpiry": {
        "title": "Valide «{{document}}»",
        "body": "{{uploader}} subió {{documentType}} de {{asset}}."
      }
    },
    "draft_created": {
      "noAssetLegacy": {
        "title": "Inspección en borrador creada",
        "body": "La inspección programada para un activo - {{template}} está lista para completarse."
      },
      "noAsset": {
        "title": "Inspección en borrador creada",
        "body": "La inspección programada para un activo - {{template}} está lista para completarse."
      },
      "default": {
        "title": "Inspección en borrador creada",
        "body": "La inspección programada para {{asset}} - {{template}} está lista para completarse."
      }
    },
    "evidence_requested": {
      "noActorNoJobLegacy": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "El revisor pidió más evidencias en una orden de trabajo. {{reason}}"
      },
      "noActorNoJob": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "El revisor pidió más evidencias en una orden de trabajo. {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "El revisor pidió más evidencias en una orden de trabajo."
      },
      "noActorNoJobNoReason": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "El revisor pidió más evidencias en una orden de trabajo."
      },
      "noActor": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "El revisor pidió más evidencias en «{{job}}». {{reason}}"
      },
      "noActorNoReason": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "El revisor pidió más evidencias en «{{job}}»."
      },
      "noJobLegacy": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "{{actor}} pidió más evidencias en una orden de trabajo. {{reason}}"
      },
      "noJob": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "{{actor}} pidió más evidencias en una orden de trabajo. {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "{{actor}} pidió más evidencias en una orden de trabajo."
      },
      "noJobNoReason": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "{{actor}} pidió más evidencias en una orden de trabajo."
      },
      "default": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "{{actor}} pidió más evidencias en «{{job}}». {{reason}}"
      },
      "noReason": {
        "title": "Se necesitan más evidencias en su orden de trabajo",
        "body": "{{actor}} pidió más evidencias en «{{job}}»."
      }
    },
    "free_period_ending": {
      "ended": {
        "title": "Su periodo gratuito ha terminado",
        "body": "Su espacio de trabajo ahora es de solo lectura. Elija un plan para seguir trabajando. No se ha eliminado nada."
      },
      "tomorrow": {
        "title": "Su periodo gratuito termina mañana",
        "body": "Elija un plan antes del {{endDate}} para seguir añadiendo y editando. En cualquier caso, no se elimina nada."
      },
      "inDays": {
        "title": "Su periodo gratuito termina en {{daysLeft}} días",
        "body": "Elija un plan antes del {{endDate}} para seguir añadiendo y editando. En cualquier caso, no se elimina nada."
      }
    },
    "inspection_approved": {
      "noActorNoAsset": {
        "title": "Su inspección se aprobó",
        "body": "El aprobador aprobó su inspección de un activo."
      },
      "noActor": {
        "title": "Su inspección se aprobó",
        "body": "El aprobador aprobó su inspección de {{asset}}."
      },
      "noAsset": {
        "title": "Su inspección se aprobó",
        "body": "{{actor}} aprobó su inspección de un activo."
      },
      "default": {
        "title": "Su inspección se aprobó",
        "body": "{{actor}} aprobó su inspección de {{asset}}."
      }
    },
    "inspection_assigned": {
      "scheduledByActorNoTemplateNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó una inspección de un activo · {{when}}."
      },
      "byActorNoTemplateNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó una inspección de un activo."
      },
      "scheduledByActorNoTemplate": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó una inspección de {{asset}} · {{when}}."
      },
      "byActorNoTemplate": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó una inspección de {{asset}}."
      },
      "scheduledByActorNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó «{{template}}» en un activo · {{when}}."
      },
      "byActorNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó «{{template}}» en un activo."
      },
      "scheduledNoTemplateNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "Inspección · Un activo · {{when}}."
      },
      "scheduledByActor": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó «{{template}}» en {{asset}} · {{when}}."
      },
      "noTemplateNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "Inspección · Un activo."
      },
      "byActor": {
        "title": "Se le asignó una inspección",
        "body": "{{actor}} le asignó «{{template}}» en {{asset}}."
      },
      "scheduledNoTemplate": {
        "title": "Se le asignó una inspección",
        "body": "Inspección · {{asset}} · {{when}}."
      },
      "scheduledNoAsset": {
        "title": "Se le asignó una inspección",
        "body": "{{template}} · Un activo · {{when}}."
      },
      "noTemplate": {
        "title": "Se le asignó una inspección",
        "body": "Inspección · {{asset}}."
      },
      "noAsset": {
        "title": "Se le asignó una inspección",
        "body": "{{template}} · Un activo."
      },
      "scheduled": {
        "title": "Se le asignó una inspección",
        "body": "{{template}} · {{asset}} · {{when}}."
      },
      "default": {
        "title": "Se le asignó una inspección",
        "body": "{{template}} · {{asset}}."
      }
    },
    "inspection_completed_for_approval": {
      "noActorNoAsset": {
        "title": "Inspección lista para su aprobación",
        "body": "Un compañero completó una inspección de un activo. Revísela y apruébela."
      },
      "noActor": {
        "title": "Inspección lista para su aprobación",
        "body": "Un compañero completó una inspección de {{asset}}. Revísela y apruébela."
      },
      "noAsset": {
        "title": "Inspección lista para su aprobación",
        "body": "{{actor}} completó una inspección de un activo. Revísela y apruébela."
      },
      "default": {
        "title": "Inspección lista para su aprobación",
        "body": "{{actor}} completó una inspección de {{asset}}. Revísela y apruébela."
      }
    },
    "inspection_reassigned": {
      "inspectionNoAsset": {
        "title": "Inspección reasignada",
        "body": "Ya no tiene asignada la inspección de este activo."
      },
      "inspection": {
        "title": "Inspección reasignada",
        "body": "Ya no tiene asignada la inspección de {{asset}}."
      },
      "scheduleNoAsset": {
        "title": "Inspección reasignada",
        "body": "Ya no tiene asignada esta inspección."
      },
      "schedule": {
        "title": "Inspección reasignada",
        "body": "Ya no tiene asignado {{asset}}."
      }
    },
    "inspection_reopened": {
      "noActorNoAsset": {
        "title": "Su inspección se reabrió",
        "body": "Un compañero reabrió su inspección de un activo."
      },
      "noActor": {
        "title": "Su inspección se reabrió",
        "body": "Un compañero reabrió su inspección de {{asset}}."
      },
      "noAsset": {
        "title": "Su inspección se reabrió",
        "body": "{{actor}} reabrió su inspección de un activo."
      },
      "default": {
        "title": "Su inspección se reabrió",
        "body": "{{actor}} reabrió su inspección de {{asset}}."
      }
    },
    "inspection_report_shared": {
      "recipientNoSharerNoAsset": {
        "title": "Informe de inspección listo",
        "body": "El inspector compartió el informe de inspección de un activo. Revíselo y apruébelo."
      },
      "recipientNoSharer": {
        "title": "Informe de inspección listo",
        "body": "El inspector compartió el informe de inspección de {{asset}}. Revíselo y apruébelo."
      },
      "recipientNoAsset": {
        "title": "Informe de inspección listo",
        "body": "{{sharer}} compartió el informe de inspección de un activo. Revíselo y apruébelo."
      },
      "recipient": {
        "title": "Informe de inspección listo",
        "body": "{{sharer}} compartió el informe de inspección de {{asset}}. Revíselo y apruébelo."
      },
      "sharerNoRecipient": {
        "title": "Informe de inspección compartido",
        "body": "Enlace de revisión listo para el destinatario."
      },
      "resentNoRecipient": {
        "title": "Informe de inspección reenviado",
        "body": "Enviado de nuevo al destinatario."
      },
      "sharer": {
        "title": "Informe de inspección compartido",
        "body": "Enlace de revisión listo para {{recipient}}."
      },
      "sharerBlankName": {
        "title": "Informe de inspección compartido",
        "body": "El enlace de revisión está listo."
      },
      "resentBlankName": {
        "title": "Informe de inspección reenviado",
        "body": "Enlace del informe actualizado."
      },
      "resent": {
        "title": "Informe de inspección reenviado",
        "body": "Enviado de nuevo a {{recipient}}."
      }
    },
    "inspection_sent_back": {
      "noActorNoAsset": {
        "title": "Su inspección se devolvió",
        "body": "Su aprobador devolvió su inspección de un activo: {{reason}}"
      },
      "noActor": {
        "title": "Su inspección se devolvió",
        "body": "Su aprobador devolvió su inspección de {{asset}}: {{reason}}"
      },
      "noAsset": {
        "title": "Su inspección se devolvió",
        "body": "{{actor}} devolvió su inspección de un activo: {{reason}}"
      },
      "default": {
        "title": "Su inspección se devolvió",
        "body": "{{actor}} devolvió su inspección de {{asset}}: {{reason}}"
      }
    },
    "inspection_unassigned": {
      "inspectionNoAsset": {
        "title": "Inspección desasignada",
        "body": "Ya no tiene asignada la inspección de este activo."
      },
      "inspection": {
        "title": "Inspección desasignada",
        "body": "Ya no tiene asignada la inspección de {{asset}}."
      },
      "scheduleNoAsset": {
        "title": "Inspección desasignada",
        "body": "Ya no tiene asignada esta inspección."
      },
      "schedule": {
        "title": "Inspección desasignada",
        "body": "Ya no tiene asignado {{asset}}."
      }
    },
    "inspection_visit_proposed": {
      "noInspection": {
        "title": "Confirme la hora de la visita",
        "body": "Hay una inspección prevista para el {{when}}: confirme que alguien puede estar allí o solicite un horario diferente."
      },
      "default": {
        "title": "Confirme la hora de la visita",
        "body": "{{inspection}} está prevista para el {{when}}: confirme que alguien puede estar allí o solicite un horario diferente."
      }
    },
    "job_accepted": {
      "noActorNoJobLegacy": {
        "title": "Orden de trabajo aceptada",
        "body": "El responsable aceptó una orden de trabajo."
      },
      "noActorNoJob": {
        "title": "Orden de trabajo aceptada",
        "body": "El responsable aceptó una orden de trabajo."
      },
      "noActor": {
        "title": "Orden de trabajo aceptada",
        "body": "El responsable aceptó «{{job}}»."
      },
      "noJobLegacy": {
        "title": "Orden de trabajo aceptada",
        "body": "{{actor}} aceptó una orden de trabajo."
      },
      "noJob": {
        "title": "Orden de trabajo aceptada",
        "body": "{{actor}} aceptó una orden de trabajo."
      },
      "default": {
        "title": "Orden de trabajo aceptada",
        "body": "{{actor}} aceptó «{{job}}»."
      }
    },
    "job_approver_assigned": {
      "noJob": {
        "title": "Responsabilidad de aprobación asignada",
        "body": "Una orden de trabajo requerirá su revisión."
      },
      "default": {
        "title": "Responsabilidad de aprobación asignada",
        "body": "{{job}} requerirá su revisión."
      }
    },
    "job_approver_removed": {
      "noJobLegacy": {
        "title": "Cambio en la responsabilidad de aprobación",
        "body": "Ya no es el aprobador de una orden de trabajo."
      },
      "noJob": {
        "title": "Cambio en la responsabilidad de aprobación",
        "body": "Ya no es el aprobador de una orden de trabajo."
      },
      "default": {
        "title": "Cambio en la responsabilidad de aprobación",
        "body": "Ya no es el aprobador de {{job}}."
      }
    },
    "job_assigned": {
      "byActorNoJobLegacy": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo · {{asset}} · vence el {{dueDate}}."
      },
      "byActorNoJob": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo · {{asset}} · vence el {{dueDate}}."
      },
      "byActorNoJobNoAssetLegacy": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo · vence el {{dueDate}}."
      },
      "byActorNoJobNoAsset": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo · vence el {{dueDate}}."
      },
      "byActor": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó «{{job}}» · {{asset}} · vence el {{dueDate}}."
      },
      "byActorNoJobNoDueLegacy": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo · {{asset}}."
      },
      "byActorNoJobNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo · {{asset}}."
      },
      "byActorNoAsset": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó «{{job}}» · vence el {{dueDate}}."
      },
      "byActorNoJobNoAssetNoDueLegacy": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo."
      },
      "byActorNoJobNoAssetNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó una orden de trabajo."
      },
      "byActorNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó «{{job}}» · {{asset}}."
      },
      "byActorNoAssetNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{actor}} le asignó «{{job}}»."
      },
      "noJob": {
        "title": "Se le asignó una orden de trabajo",
        "body": "Una orden de trabajo · {{asset}} · vence el {{dueDate}}."
      },
      "noJobNoAsset": {
        "title": "Se le asignó una orden de trabajo",
        "body": "Una orden de trabajo · vence el {{dueDate}}."
      },
      "default": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{job}} · {{asset}} · vence el {{dueDate}}."
      },
      "noJobNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "Una orden de trabajo · {{asset}}."
      },
      "noAsset": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{job}} · vence el {{dueDate}}."
      },
      "noJobNoAssetNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "Una orden de trabajo."
      },
      "noDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{job}} · {{asset}}."
      },
      "noAssetNoDue": {
        "title": "Se le asignó una orden de trabajo",
        "body": "{{job}}."
      }
    },
    "job_cancelled": {
      "noActorNoJobLegacy": {
        "title": "Orden de trabajo cancelada",
        "body": "Un compañero canceló una orden de trabajo de {{asset}}."
      },
      "noActorNoJob": {
        "title": "Orden de trabajo cancelada",
        "body": "Un compañero canceló una orden de trabajo de {{asset}}."
      },
      "noActorNoJobNoAssetLegacy": {
        "title": "Orden de trabajo cancelada",
        "body": "Un compañero canceló una orden de trabajo."
      },
      "noActorNoJobNoAsset": {
        "title": "Orden de trabajo cancelada",
        "body": "Un compañero canceló una orden de trabajo."
      },
      "noActor": {
        "title": "Orden de trabajo cancelada",
        "body": "Un compañero canceló «{{job}}» de {{asset}}."
      },
      "noActorNoAsset": {
        "title": "Orden de trabajo cancelada",
        "body": "Un compañero canceló «{{job}}»."
      },
      "noJobLegacy": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló una orden de trabajo de {{asset}}."
      },
      "noJob": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló una orden de trabajo de {{asset}}."
      },
      "noJobNoAssetLegacy": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló una orden de trabajo."
      },
      "noJobNoAsset": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló una orden de trabajo."
      },
      "default": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló «{{job}}» de {{asset}}."
      },
      "noAsset": {
        "title": "Orden de trabajo cancelada",
        "body": "{{actor}} canceló «{{job}}»."
      }
    },
    "job_completion_approved": {
      "noRequesterNoJob": {
        "title": "Finalización aprobada",
        "body": "El solicitante aprobó la finalización de la orden de trabajo."
      },
      "noRequester": {
        "title": "Finalización aprobada",
        "body": "El solicitante aprobó la finalización de {{job}}."
      },
      "noJob": {
        "title": "Finalización aprobada",
        "body": "{{requester}} aprobó la finalización de la orden de trabajo."
      },
      "default": {
        "title": "Finalización aprobada",
        "body": "{{requester}} aprobó la finalización de {{job}}."
      }
    },
    "job_declined": {
      "noActorNoJobLegacy": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "El responsable rechazó una orden de trabajo. Motivo: {{reason}}. Asígnela a otra persona para que siga avanzando."
      },
      "noActorNoJob": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "El responsable rechazó una orden de trabajo. Motivo: {{reason}} Asígnela a otra persona para que siga avanzando."
      },
      "noActor": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "El responsable rechazó «{{job}}». Motivo: {{reason}} Asígnela a otra persona para que siga avanzando."
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "El responsable rechazó una orden de trabajo. Asígnela a otra persona para que siga avanzando."
      },
      "noActorNoJobNoReason": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "El responsable rechazó una orden de trabajo. Asígnela a otra persona para que siga avanzando."
      },
      "noJobLegacy": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "{{actor}} rechazó una orden de trabajo. Motivo: {{reason}}. Asígnela a otra persona para que siga avanzando."
      },
      "noJob": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "{{actor}} rechazó una orden de trabajo. Motivo: {{reason}} Asígnela a otra persona para que siga avanzando."
      },
      "noActorNoReason": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "El responsable rechazó «{{job}}». Asígnela a otra persona para que siga avanzando."
      },
      "default": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "{{actor}} rechazó «{{job}}». Motivo: {{reason}} Asígnela a otra persona para que siga avanzando."
      },
      "noJobNoReasonLegacy": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "{{actor}} rechazó una orden de trabajo. Asígnela a otra persona para que siga avanzando."
      },
      "noJobNoReason": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "{{actor}} rechazó una orden de trabajo. Asígnela a otra persona para que siga avanzando."
      },
      "noReason": {
        "title": "Orden de trabajo rechazada: reasígnela",
        "body": "{{actor}} rechazó «{{job}}». Asígnela a otra persona para que siga avanzando."
      }
    },
    "job_message": {
      "photoNoSenderLegacy": {
        "title": "Nuevo mensaje en la orden de trabajo.",
        "body": "Alguien compartió una foto."
      },
      "photoNoSender": {
        "title": "Nuevo mensaje en la orden de trabajo.",
        "body": "Alguien compartió una foto."
      },
      "photoLegacy": {
        "title": "Nuevo mensaje en la orden de trabajo.",
        "body": "{{sender}} compartió una foto."
      },
      "photo": {
        "title": "Nuevo mensaje en la orden de trabajo.",
        "body": "{{sender}} compartió una foto."
      },
      "emptyUpdateNoSender": {
        "title": "Nuevo mensaje en la orden de trabajo",
        "body": "Alguien: Actualización"
      },
      "noSender": {
        "title": "Nuevo mensaje en la orden de trabajo",
        "body": "Alguien: {{message}}"
      },
      "emptyUpdate": {
        "title": "Nuevo mensaje en la orden de trabajo",
        "body": "{{sender}}: Actualización"
      },
      "default": {
        "title": "Nuevo mensaje en la orden de trabajo",
        "body": "{{sender}}: {{message}}"
      }
    },
    "job_reassigned": {
      "noJobLegacy": {
        "title": "Orden de trabajo reasignada",
        "body": "Ya no tiene asignada una orden de trabajo."
      },
      "noJob": {
        "title": "Orden de trabajo reasignada",
        "body": "Ya no tiene asignada una orden de trabajo."
      },
      "default": {
        "title": "Orden de trabajo reasignada",
        "body": "Ya no tiene asignada la orden de trabajo {{job}}."
      }
    },
    "job_report_shared": {
      "recipientNoSharerNoJobNoAssetLegacy": {
        "title": "Informe de la orden de trabajo listo",
        "body": "El equipo compartió el informe de finalización de una orden de trabajo de un activo."
      },
      "recipientNoSharerNoJobNoAsset": {
        "title": "Informe de la orden de trabajo listo",
        "body": "El equipo compartió el informe de finalización de una orden de trabajo de un activo."
      },
      "recipientNoSharerNoAsset": {
        "title": "Informe de la orden de trabajo listo",
        "body": "El equipo compartió el informe de finalización de «{{job}}» de un activo."
      },
      "recipientNoJobNoAssetLegacy": {
        "title": "Informe de la orden de trabajo listo",
        "body": "{{sharer}} compartió el informe de finalización de una orden de trabajo de un activo."
      },
      "recipientNoJobNoAsset": {
        "title": "Informe de la orden de trabajo listo",
        "body": "{{sharer}} compartió el informe de finalización de una orden de trabajo de un activo."
      },
      "recipientNoSharerNoJobLegacy": {
        "title": "Informe de la orden de trabajo listo",
        "body": "El equipo compartió el informe de finalización de una orden de trabajo de {{asset}}."
      },
      "recipientNoSharerNoJob": {
        "title": "Informe de la orden de trabajo listo",
        "body": "El equipo compartió el informe de finalización de una orden de trabajo de {{asset}}."
      },
      "recipientNoAsset": {
        "title": "Informe de la orden de trabajo listo",
        "body": "{{sharer}} compartió el informe de finalización de «{{job}}» de un activo."
      },
      "recipientNoSharer": {
        "title": "Informe de la orden de trabajo listo",
        "body": "El equipo compartió el informe de finalización de «{{job}}» de {{asset}}."
      },
      "recipientNoJobLegacy": {
        "title": "Informe de la orden de trabajo listo",
        "body": "{{sharer}} compartió el informe de finalización de una orden de trabajo de {{asset}}."
      },
      "recipientNoJob": {
        "title": "Informe de la orden de trabajo listo",
        "body": "{{sharer}} compartió el informe de finalización de una orden de trabajo de {{asset}}."
      },
      "sharerNoRecipient": {
        "title": "Informe de finalización de la orden de trabajo compartido",
        "body": "Enlace del informe enviado al destinatario."
      },
      "recipient": {
        "title": "Informe de la orden de trabajo listo",
        "body": "{{sharer}} compartió el informe de finalización de «{{job}}» de {{asset}}."
      },
      "resentNoRecipient": {
        "title": "Informe de finalización de la orden de trabajo reenviado",
        "body": "Enviado de nuevo al destinatario."
      },
      "sharer": {
        "title": "Informe de finalización de la orden de trabajo compartido",
        "body": "Enlace del informe enviado a {{recipient}}."
      },
      "sharerBlankName": {
        "title": "Informe de finalización de la orden de trabajo compartido",
        "body": "El enlace del informe está listo."
      },
      "resentBlankName": {
        "title": "Informe de finalización de la orden de trabajo reenviado",
        "body": "Enlace del informe actualizado."
      },
      "resent": {
        "title": "Informe de finalización de la orden de trabajo reenviado",
        "body": "Enviado de nuevo a {{recipient}}."
      }
    },
    "job_requester_accepted": {
      "verifierNoRequesterNoJob": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "El solicitante aceptó la finalización de la orden de trabajo. Verifique la orden de trabajo para cerrarla."
      },
      "verifierNoRequester": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "El solicitante aceptó la finalización de {{job}}. Verifique la orden de trabajo para cerrarla."
      },
      "verifierNoJob": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "{{requester}} aceptó la finalización de la orden de trabajo. Verifique la orden de trabajo para cerrarla."
      },
      "verifier": {
        "title": "El solicitante está conforme: verifique para cerrar",
        "body": "{{requester}} aceptó la finalización de {{job}}. Verifique la orden de trabajo para cerrarla."
      },
      "informedNoRequesterNoJob": {
        "title": "El solicitante aceptó el trabajo",
        "body": "El solicitante aceptó la finalización de la orden de trabajo."
      },
      "informedNoRequester": {
        "title": "El solicitante aceptó el trabajo",
        "body": "El solicitante aceptó la finalización de {{job}}."
      },
      "informedNoJob": {
        "title": "El solicitante aceptó el trabajo",
        "body": "{{requester}} aceptó la finalización de la orden de trabajo."
      },
      "informed": {
        "title": "El solicitante aceptó el trabajo",
        "body": "{{requester}} aceptó la finalización de {{job}}."
      }
    },
    "job_rework_requested": {
      "noRequesterNoJob": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en la orden de trabajo: {{note}}"
      },
      "noRequesterNoJobNoNote": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en la orden de trabajo."
      },
      "noRequester": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en {{job}}: {{note}}"
      },
      "noRequesterNoNote": {
        "title": "Retrabajo solicitado",
        "body": "El solicitante pidió un retrabajo en {{job}}."
      },
      "noJob": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en la orden de trabajo: {{note}}"
      },
      "noJobNoNote": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en la orden de trabajo."
      },
      "default": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en {{job}}: {{note}}"
      },
      "noNote": {
        "title": "Retrabajo solicitado",
        "body": "{{requester}} pidió un retrabajo en {{job}}."
      }
    },
    "job_scheduled": {
      "noActorNoJobLegacy": {
        "title": "Visita prevista",
        "body": "El responsable programó una orden de trabajo para el {{when}}."
      },
      "noActorNoJob": {
        "title": "Visita prevista",
        "body": "El responsable programó una orden de trabajo para el {{when}}."
      },
      "noActor": {
        "title": "Visita prevista",
        "body": "El responsable programó «{{job}}» para el {{when}}."
      },
      "noJobLegacy": {
        "title": "Visita prevista",
        "body": "{{actor}} programó una orden de trabajo para el {{when}}."
      },
      "noJob": {
        "title": "Visita prevista",
        "body": "{{actor}} programó una orden de trabajo para el {{when}}."
      },
      "default": {
        "title": "Visita prevista",
        "body": "{{actor}} programó «{{job}}» para el {{when}}."
      }
    },
    "job_unassigned": {
      "noJobLegacy": {
        "title": "Orden de trabajo desasignada",
        "body": "Ya no tiene asignada una orden de trabajo."
      },
      "noJob": {
        "title": "Orden de trabajo desasignada",
        "body": "Ya no tiene asignada una orden de trabajo."
      },
      "default": {
        "title": "Orden de trabajo desasignada",
        "body": "Ya no tiene asignada la orden de trabajo {{job}}."
      }
    },
    "job_verified": {
      "noActorNoJobLegacy": {
        "title": "Su trabajo se verificó",
        "body": "El propietario verificó una orden de trabajo. La orden de trabajo está cerrada."
      },
      "noActorNoJob": {
        "title": "Su trabajo se verificó",
        "body": "El propietario verificó una orden de trabajo. La orden de trabajo está cerrada."
      },
      "noActor": {
        "title": "Su trabajo se verificó",
        "body": "El propietario verificó «{{job}}». La orden de trabajo está cerrada."
      },
      "noJobLegacy": {
        "title": "Su trabajo se verificó",
        "body": "{{actor}} verificó una orden de trabajo. La orden de trabajo está cerrada."
      },
      "noJob": {
        "title": "Su trabajo se verificó",
        "body": "{{actor}} verificó una orden de trabajo. La orden de trabajo está cerrada."
      },
      "default": {
        "title": "Su trabajo se verificó",
        "body": "{{actor}} verificó «{{job}}». La orden de trabajo está cerrada."
      }
    },
    "job_visit_proposed": {
      "noJob": {
        "title": "Confirme la hora de la visita",
        "body": "Hay una orden de trabajo prevista para el {{when}}: confirme que alguien puede estar allí o solicite un horario diferente."
      },
      "default": {
        "title": "Confirme la hora de la visita",
        "body": "{{job}} está prevista para el {{when}}: confirme que alguien puede estar allí o solicite un horario diferente."
      }
    },
    "mcp_action_proposed": {
      "oneNoClient": {
        "title": "Solicitudes de IA para aprobar",
        "body": "Un asistente de IA solicita: {{action}}. Apruebe o rechace la solicitud antes de que caduque."
      },
      "many": {
        "title": "Solicitudes de IA para aprobar",
        "body": "{{total}} cambios de asistentes de IA esperan su aprobación."
      },
      "one": {
        "title": "Solicitudes de IA para aprobar",
        "body": "{{client}} solicita: {{action}}. Apruebe o rechace la solicitud antes de que caduque."
      }
    },
    "member_removed_reassign": {
      "noLeaverNoJobLegacy": {
        "title": "Reasigne el trabajo pendiente",
        "body": "Alguien dejó el equipo con una orden de trabajo todavía asignada. Asígnela a otra persona."
      },
      "noLeaverNoJob": {
        "title": "Reasigne el trabajo pendiente",
        "body": "Alguien dejó el equipo con una orden de trabajo todavía asignada. Asígnela a otra persona."
      },
      "noLeaver": {
        "title": "Reasigne el trabajo pendiente",
        "body": "Alguien dejó el equipo con «{{job}}» todavía asignada. Asígnela a otra persona."
      },
      "noJobLegacy": {
        "title": "Reasigne el trabajo pendiente",
        "body": "{{leaver}} dejó el equipo con una orden de trabajo todavía asignada. Asígnela a otra persona."
      },
      "noJob": {
        "title": "Reasigne el trabajo pendiente",
        "body": "{{leaver}} dejó el equipo con una orden de trabajo todavía asignada. Asígnela a otra persona."
      },
      "default": {
        "title": "Reasigne el trabajo pendiente",
        "body": "{{leaver}} dejó el equipo con «{{job}}» todavía asignada. Asígnela a otra persona."
      }
    },
    "mfa_reset_requested": {
      "noMember": {
        "title": "Solicitud para restablecer la verificación en dos pasos",
        "body": "Un miembro del espacio de trabajo no puede iniciar sesión con la verificación en dos pasos y pidió restablecerla."
      },
      "default": {
        "title": "Solicitud para restablecer la verificación en dos pasos",
        "body": "{{member}} no puede iniciar sesión con la verificación en dos pasos y pidió restablecerla."
      }
    },
    "plan_changed": {
      "byActorLegacy": {
        "title": "Su plan del {{day}} ha cambiado",
        "body": "{{actor}} cambió {{total}} elementos de su día. Abra Mi día para verlo."
      },
      "byActor": {
        "title": "Su plan del {{day}} ha cambiado",
        "body": "{{actor}} cambió {{total}} elementos de su día. Abra Mi día para verlo."
      },
      "defaultLegacy": {
        "title": "Su plan del {{day}} ha cambiado",
        "body": "Cambios: {{total}} elementos de su día. Abra Mi día para verlo."
      },
      "default": {
        "title": "Su plan del {{day}} ha cambiado",
        "body": "Cambios: {{total}} elementos de su día. Abra Mi día para verlo."
      },
      "byActorOne": {
        "title": "Su plan del {{day}} ha cambiado",
        "body": "{{actor}} cambió {{total}} elemento de su día. Abra Mi día para verlo."
      },
      "one": {
        "title": "Su plan del {{day}} ha cambiado",
        "body": "Cambios: {{total}} elemento de su día. Abra Mi día para verlo."
      }
    },
    "plan_review": {
      "default": {
        "title": "El plan del {{day}} necesita una revisión",
        "body": "Algo del día ya no encaja. Abra el calendario para revisar el plan sugerido."
      }
    },
    "quote_declined": {
      "noContractor": {
        "title": "Solicitud de presupuesto rechazada",
        "body": "Un contratista rechazó presupuestar {{job}}."
      },
      "noContractorNoJob": {
        "title": "Solicitud de presupuesto rechazada",
        "body": "Un contratista rechazó enviar un presupuesto."
      },
      "default": {
        "title": "Solicitud de presupuesto rechazada",
        "body": "{{contractor}} rechazó presupuestar {{job}}."
      },
      "noJob": {
        "title": "Solicitud de presupuesto rechazada",
        "body": "{{contractor}} rechazó enviar un presupuesto."
      }
    },
    "quote_rejected": {
      "noJobLegacy": {
        "title": "Presupuesto no seleccionado",
        "body": "Su presupuesto para una orden de trabajo se revisó, pero no se seleccionó."
      },
      "noJob": {
        "title": "Presupuesto no seleccionado",
        "body": "Su presupuesto para una orden de trabajo se revisó, pero no se seleccionó."
      },
      "default": {
        "title": "Presupuesto no seleccionado",
        "body": "Su presupuesto para «{{job}}» se revisó, pero no se seleccionó."
      }
    },
    "quote_requested": {
      "noJobLegacy": {
        "title": "Solicitud de presupuesto",
        "body": "Se le ha invitado a enviar un presupuesto para: una orden de trabajo."
      },
      "noJob": {
        "title": "Solicitud de presupuesto",
        "body": "Se le ha invitado a enviar un presupuesto para: una orden de trabajo."
      },
      "default": {
        "title": "Solicitud de presupuesto",
        "body": "Se le ha invitado a enviar un presupuesto para: {{job}}."
      }
    },
    "quote_submitted": {
      "taxNoContractorNoJob": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista presupuestó {{amount}} con impuestos incluidos para una orden de trabajo. Revise los presupuestos."
      },
      "taxNoContractor": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista presupuestó {{amount}} con impuestos incluidos para «{{job}}». Revise los presupuestos."
      },
      "taxNoJob": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} presupuestó {{amount}} con impuestos incluidos para una orden de trabajo. Revise los presupuestos."
      },
      "tax": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} presupuestó {{amount}} con impuestos incluidos para «{{job}}». Revise los presupuestos."
      },
      "noContractorNoPriceNoJobLegacy": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista envió un presupuesto para una orden de trabajo. Revise los presupuestos."
      },
      "noContractorNoPriceNoJob": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista envió un presupuesto para una orden de trabajo. Revise los presupuestos."
      },
      "noContractorNoPrice": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista envió un presupuesto para «{{job}}». Revise los presupuestos."
      },
      "noContractorNoJobLegacy": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista presupuestó {{amount}} para una orden de trabajo. Revise los presupuestos."
      },
      "noContractorNoJob": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista presupuestó {{amount}} para una orden de trabajo. Revise los presupuestos."
      },
      "noPriceNoJobLegacy": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} envió un presupuesto para una orden de trabajo. Revise los presupuestos."
      },
      "noPriceNoJob": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} envió un presupuesto para una orden de trabajo. Revise los presupuestos."
      },
      "noContractor": {
        "title": "Nuevo presupuesto recibido",
        "body": "Un contratista presupuestó {{amount}} para «{{job}}». Revise los presupuestos."
      },
      "noPrice": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} envió un presupuesto para «{{job}}». Revise los presupuestos."
      },
      "noJobLegacy": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} presupuestó {{amount}} para una orden de trabajo. Revise los presupuestos."
      },
      "noJob": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} presupuestó {{amount}} para una orden de trabajo. Revise los presupuestos."
      },
      "default": {
        "title": "Nuevo presupuesto recibido",
        "body": "{{contractor}} presupuestó {{amount}} para «{{job}}». Revise los presupuestos."
      }
    },
    "report_access_declined": {
      "noAsset": {
        "title": "Acceso al informe rechazado",
        "body": "Se rechazó su solicitud para ver el informe del activo."
      },
      "default": {
        "title": "Acceso al informe rechazado",
        "body": "Se rechazó su solicitud para ver el informe de {{asset}}."
      }
    },
    "report_access_granted": {
      "noAsset": {
        "title": "Acceso al informe aprobado",
        "body": "Ya puede ver el informe del activo."
      },
      "default": {
        "title": "Acceso al informe aprobado",
        "body": "Ya puede ver el informe de {{asset}}."
      }
    },
    "report_access_requested": {
      "noRequesterNoAsset": {
        "title": "Acceso al informe solicitado.",
        "body": "Alguien pidió ver el informe de un activo."
      },
      "noAsset": {
        "title": "Acceso al informe solicitado.",
        "body": "{{requester}} pidió ver el informe de un activo."
      },
      "noRequester": {
        "title": "Acceso al informe solicitado.",
        "body": "Alguien pidió ver el informe de {{asset}}."
      },
      "default": {
        "title": "Acceso al informe solicitado.",
        "body": "{{requester}} pidió ver el informe de {{asset}}."
      },
      "noRequesterNoAssetLegacy": {
        "title": "Acceso al informe solicitado.",
        "body": "Alguien pidió ver el informe de un activo."
      },
      "noAssetLegacy": {
        "title": "Acceso al informe solicitado.",
        "body": "{{requester}} pidió ver el informe de un activo."
      },
      "noRequesterLegacy": {
        "title": "Acceso al informe solicitado.",
        "body": "Alguien pidió ver el informe de {{asset}}."
      },
      "defaultLegacy": {
        "title": "Acceso al informe solicitado.",
        "body": "{{requester}} pidió ver el informe de {{asset}}."
      }
    },
    "request_assigned": {
      "default": {
        "title": "Se le asignó una solicitud",
        "body": "{{request}} espera una acción suya."
      },
      "byActor": {
        "title": "Se le asignó una solicitud",
        "body": "{{actor}} le asignó «{{request}}»."
      }
    },
    "request_reassigned": {
      "default": {
        "title": "Solicitud reasignada",
        "body": "Ya no tiene asignada la solicitud {{request}}."
      }
    },
    "request_team_assigned": {
      "noTeam": {
        "title": "Solicitud trasladada a su equipo",
        "body": "Su equipo gestiona ahora {{request}}."
      },
      "default": {
        "title": "Solicitud trasladada a su equipo",
        "body": "{{team}} gestiona ahora {{request}}."
      }
    },
    "request_team_removed": {
      "default": {
        "title": "Solicitud trasladada fuera de su equipo",
        "body": "Su equipo ya no gestiona {{request}}."
      }
    },
    "rework_requested": {
      "noActorNoJobLegacy": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "El revisor devolvió una orden de trabajo para retrabajo. Motivo: {{reason}}."
      },
      "noActorNoJob": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "El revisor devolvió una orden de trabajo para retrabajo. Motivo: {{reason}}"
      },
      "noActor": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "El revisor devolvió «{{job}}» para retrabajo. Motivo: {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "El revisor devolvió una orden de trabajo para retrabajo."
      },
      "noActorNoJobNoReason": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "El revisor devolvió una orden de trabajo para retrabajo."
      },
      "noJobLegacy": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "{{actor}} devolvió una orden de trabajo para retrabajo. Motivo: {{reason}}."
      },
      "noJob": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "{{actor}} devolvió una orden de trabajo para retrabajo. Motivo: {{reason}}"
      },
      "noActorNoReason": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "El revisor devolvió «{{job}}» para retrabajo."
      },
      "default": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "{{actor}} devolvió «{{job}}» para retrabajo. Motivo: {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "{{actor}} devolvió una orden de trabajo para retrabajo."
      },
      "noJobNoReason": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "{{actor}} devolvió una orden de trabajo para retrabajo."
      },
      "noReason": {
        "title": "Su orden de trabajo necesita un retrabajo",
        "body": "{{actor}} devolvió «{{job}}» para retrabajo."
      }
    },
    "share_message": {
      "noSender": {
        "title": "Nuevo mensaje en el informe de inspección",
        "body": "Alguien: {{message}}"
      },
      "default": {
        "title": "Nuevo mensaje en el informe de inspección",
        "body": "{{sender}}: {{message}}"
      }
    },
    "share_response_submitted": {
      "closedOnBehalfNoActorNoRecipient": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe de {{asset}} en nombre del destinatario: {{reason}}"
      },
      "closedOnBehalfNoActorNoRecipientNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe de {{asset}} en nombre del destinatario."
      },
      "approvedOnBehalfNoActorNoRecipient": {
        "title": "Informe de inspección aprobado",
        "body": "El equipo del activo aprobó el informe de {{asset}} en nombre del destinatario."
      },
      "closedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe en nombre del destinatario: {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoRecipientNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe en nombre del destinatario."
      },
      "approvedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "Informe de inspección aprobado",
        "body": "El equipo del activo aprobó el informe en nombre del destinatario."
      },
      "closedOnBehalfNoActor": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe de {{asset}} en nombre de {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoRecipient": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe de {{asset}} en nombre del destinatario: {{reason}}"
      },
      "closedOnBehalfNoActorNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe de {{asset}} en nombre de {{recipient}}."
      },
      "closedOnBehalfNoRecipientNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe de {{asset}} en nombre del destinatario."
      },
      "approvedOnBehalfNoActor": {
        "title": "Informe de inspección aprobado",
        "body": "El equipo del activo aprobó el informe de {{asset}} en nombre de {{recipient}}."
      },
      "changesNoSigner": {
        "title": "Cambios solicitados en un informe",
        "body": "El destinatario solicitó cambios en el informe de {{asset}}: {{reason}}"
      },
      "approvedOnBehalfNoRecipient": {
        "title": "Informe de inspección aprobado",
        "body": "{{actor}} aprobó el informe de {{asset}} en nombre del destinatario."
      },
      "changesNoSignerNoReason": {
        "title": "Cambios solicitados en un informe",
        "body": "El destinatario solicitó cambios en el informe de {{asset}}."
      },
      "closedOnBehalfNoActorNoAsset": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe en nombre de {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoAssetNoRecipient": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe en nombre del destinatario: {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "El equipo del activo cerró el informe en nombre de {{recipient}}."
      },
      "closedOnBehalfNoAssetNoRecipientNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe en nombre del destinatario."
      },
      "approvedOnBehalfNoActorNoAsset": {
        "title": "Informe de inspección aprobado",
        "body": "El equipo del activo aprobó el informe en nombre de {{recipient}}."
      },
      "changesNoSignerNoAsset": {
        "title": "Cambios solicitados en un informe",
        "body": "El destinatario solicitó cambios en el informe: {{reason}}"
      },
      "approvedOnBehalfNoAssetNoRecipient": {
        "title": "Informe de inspección aprobado",
        "body": "{{actor}} aprobó el informe en nombre del destinatario."
      },
      "changesNoSignerNoAssetNoReason": {
        "title": "Cambios solicitados en un informe",
        "body": "El destinatario solicitó cambios en el informe."
      },
      "closedOnBehalf": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe de {{asset}} en nombre de {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe de {{asset}} en nombre de {{recipient}}."
      },
      "changes": {
        "title": "Cambios solicitados en un informe",
        "body": "{{signer}} solicitó cambios en el informe de {{asset}}: {{reason}}"
      },
      "approvedNoSigner": {
        "title": "Informe de inspección aprobado",
        "body": "El destinatario aprobó el informe de {{asset}}."
      },
      "approvedOnBehalf": {
        "title": "Informe de inspección aprobado",
        "body": "{{actor}} aprobó el informe de {{asset}} en nombre de {{recipient}}."
      },
      "changesNoReason": {
        "title": "Cambios solicitados en un informe",
        "body": "{{signer}} solicitó cambios en el informe de {{asset}}."
      },
      "closedOnBehalfNoAsset": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe en nombre de {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoAssetNoReason": {
        "title": "Informe cerrado sin respuesta",
        "body": "{{actor}} cerró el informe en nombre de {{recipient}}."
      },
      "changesNoAsset": {
        "title": "Cambios solicitados en un informe",
        "body": "{{signer}} solicitó cambios en el informe: {{reason}}"
      },
      "approvedNoSignerNoAsset": {
        "title": "Informe de inspección aprobado",
        "body": "El destinatario aprobó el informe."
      },
      "approvedOnBehalfNoAsset": {
        "title": "Informe de inspección aprobado",
        "body": "{{actor}} aprobó el informe en nombre de {{recipient}}."
      },
      "changesNoAssetNoReason": {
        "title": "Cambios solicitados en un informe",
        "body": "{{signer}} solicitó cambios en el informe."
      },
      "approved": {
        "title": "Informe de inspección aprobado",
        "body": "{{signer}} aprobó el informe de {{asset}}."
      },
      "approvedNoAsset": {
        "title": "Informe de inspección aprobado",
        "body": "{{signer}} aprobó el informe."
      }
    },
    "site_team_assigned": {
      "noTeam": {
        "title": "Nuevo sitio en su equipo",
        "body": "{{site}} se asignó a su equipo."
      },
      "default": {
        "title": "Nuevo sitio en su equipo",
        "body": "{{site}} se asignó a {{team}}."
      }
    },
    "site_team_removed": {
      "default": {
        "title": "Sitio trasladado fuera de su equipo",
        "body": "{{site}} ya no está asignado a su equipo."
      }
    },
    "stalled_work_digest": {
      "many": {
        "title": "{{total}} elementos esperan a alguien",
        "body": "{{itemTitle}} · {{asset}}. {{line}} Y {{moreCount}} más."
      },
      "manyNoAsset": {
        "title": "{{total}} elementos esperan a alguien",
        "body": "{{itemTitle}}. {{line}} Y {{moreCount}} más."
      },
      "one": {
        "title": "Hay algo que espera a alguien",
        "body": "{{itemTitle}} · {{asset}}. {{line}}"
      },
      "oneNoAsset": {
        "title": "Hay algo que espera a alguien",
        "body": "{{itemTitle}}. {{line}}"
      }
    },
    "team_admin_approved": {
      "noMemberLegacy": {
        "title": "Un miembro del equipo ahora es administrador",
        "body": "El propietario aprobó su solicitud para un miembro del equipo."
      },
      "noMember": {
        "title": "Un miembro del equipo ahora es administrador",
        "body": "El propietario aprobó su solicitud para un miembro del equipo."
      },
      "default": {
        "title": "{{member}} ahora es administrador",
        "body": "El propietario aprobó su solicitud para {{member}}."
      }
    },
    "team_admin_declined": {
      "noMemberLegacy": {
        "title": "Solicitud de administrador rechazada",
        "body": "El propietario rechazó su solicitud para que un miembro del equipo sea administrador."
      },
      "noMember": {
        "title": "Solicitud de administrador rechazada",
        "body": "El propietario rechazó su solicitud para que un miembro del equipo sea administrador."
      },
      "default": {
        "title": "Solicitud de administrador rechazada",
        "body": "El propietario rechazó su solicitud para que {{member}} sea administrador."
      }
    },
    "team_admin_requested": {
      "noMemberNoTeamLegacy": {
        "title": "¿Hacer administrador a un miembro del equipo?",
        "body": "Su equipo: un administrador solicita que un miembro del equipo sea administrador."
      },
      "noMemberNoTeam": {
        "title": "¿Hacer administrador a un miembro del equipo?",
        "body": "Su equipo: un administrador solicita que un miembro del equipo sea administrador."
      },
      "noMemberLegacy": {
        "title": "¿Hacer administrador a un miembro del equipo?",
        "body": "{{team}}: un administrador solicita que un miembro del equipo sea administrador."
      },
      "noMember": {
        "title": "¿Hacer administrador a un miembro del equipo?",
        "body": "{{team}}: un administrador solicita que un miembro del equipo sea administrador."
      },
      "noTeam": {
        "title": "¿Hacer administrador a {{member}}?",
        "body": "Su equipo: un administrador solicita que {{member}} sea administrador."
      },
      "default": {
        "title": "¿Hacer administrador a {{member}}?",
        "body": "{{team}}: un administrador solicita que {{member}} sea administrador."
      }
    },
    "team_invite_accepted": {
      "noTeam": {
        "title": "Invitación al espacio de trabajo aceptada",
        "body": "{{email}} aceptó la invitación a su equipo."
      },
      "default": {
        "title": "Invitación al espacio de trabajo aceptada",
        "body": "{{email}} aceptó la invitación a {{team}}."
      }
    },
    "team_invite_declined": {
      "noTeam": {
        "title": "Invitación al espacio de trabajo rechazada",
        "body": "{{email}} rechazó la invitación a su equipo."
      },
      "default": {
        "title": "Invitación al espacio de trabajo rechazada",
        "body": "{{email}} rechazó la invitación a {{team}}."
      }
    },
    "team_invited": {
      "noTeam": {
        "title": "Invitación al espacio de trabajo",
        "body": "Se le invitó a unirse a un equipo del espacio de trabajo."
      },
      "default": {
        "title": "Invitación al espacio de trabajo",
        "body": "Se le invitó a unirse a {{team}}."
      }
    },
    "team_member_added": {
      "noTeam": {
        "title": "Se le añadió a un equipo del espacio de trabajo",
        "body": "Su equipo."
      },
      "default": {
        "title": "Se le añadió a un equipo del espacio de trabajo",
        "body": "{{team}}."
      }
    },
    "team_member_removed": {
      "noTeam": {
        "title": "Se le quitó de un equipo del espacio de trabajo",
        "body": "Su equipo."
      },
      "default": {
        "title": "Se le quitó de un equipo del espacio de trabajo",
        "body": "{{team}}."
      }
    },
    "team_member_role_changed": {
      "noTeam": {
        "title": "Cambio de rol en el espacio de trabajo",
        "body": "Su equipo · rol: {{role}}"
      },
      "default": {
        "title": "Cambio de rol en el espacio de trabajo",
        "body": "{{team}} · rol: {{role}}"
      }
    },
    "team_ownership_accepted": {
      "noWorkspace": {
        "title": "Propiedad del espacio de trabajo aceptada",
        "body": "Se aceptó la transferencia de la propiedad del espacio de trabajo."
      },
      "default": {
        "title": "Propiedad del espacio de trabajo aceptada",
        "body": "Se aceptó la transferencia de la propiedad de {{workspace}}."
      }
    },
    "team_ownership_cancelled": {
      "noWorkspace": {
        "title": "Transferencia de la propiedad del espacio de trabajo cancelada",
        "body": "Se canceló la transferencia de la propiedad del espacio de trabajo."
      },
      "default": {
        "title": "Transferencia de la propiedad del espacio de trabajo cancelada",
        "body": "Se canceló la transferencia de la propiedad de {{workspace}}."
      }
    },
    "team_ownership_declined": {
      "noWorkspace": {
        "title": "Propiedad del espacio de trabajo rechazada",
        "body": "Se rechazó la transferencia de la propiedad del espacio de trabajo."
      },
      "default": {
        "title": "Propiedad del espacio de trabajo rechazada",
        "body": "Se rechazó la transferencia de la propiedad de {{workspace}}."
      }
    },
    "team_ownership_expired": {
      "noWorkspaceLegacy": {
        "title": "Transferencia de la propiedad del espacio de trabajo caducada",
        "body": "La transferencia de la propiedad del espacio de trabajo caducó."
      },
      "noWorkspace": {
        "title": "Transferencia de la propiedad del espacio de trabajo caducada",
        "body": "La transferencia de la propiedad del espacio de trabajo caducó."
      },
      "defaultLegacy": {
        "title": "Transferencia de la propiedad del espacio de trabajo caducada",
        "body": "La transferencia de la propiedad de {{workspace}} caducó."
      },
      "default": {
        "title": "Transferencia de la propiedad del espacio de trabajo caducada",
        "body": "La transferencia de la propiedad de {{workspace}} caducó."
      }
    },
    "team_ownership_requested": {
      "noWorkspace": {
        "title": "Se le ofrece la propiedad de un espacio de trabajo",
        "body": "Un espacio de trabajo espera su decisión."
      },
      "default": {
        "title": "Se le ofrece la propiedad de un espacio de trabajo",
        "body": "{{workspace}} espera su decisión."
      }
    },
    "work_change_approved": {
      "byPolicyNoWork": {
        "title": "Omitido según la política del plan: trabajo programado",
        "body": "{{reason}}"
      },
      "byPolicy": {
        "title": "Omitido según la política del plan: {{work}}",
        "body": "{{reason}}"
      },
      "decided": {
        "title": "Cambio aprobado",
        "body": "{{action}} aprobada"
      }
    },
    "work_change_rejected": {
      "default": {
        "title": "Cambio no aprobado",
        "body": "Este trabajo sigue pendiente"
      }
    },
    "work_change_requested": {
      "noWork": {
        "title": "Cambio solicitado: trabajo programado",
        "body": "{{reason}}"
      },
      "default": {
        "title": "Cambio solicitado: {{work}}",
        "body": "{{reason}}"
      }
    },
    "work_needs_assignee": {
      "raisedNoAsset": {
        "title": "Aún no hay nadie asignado",
        "body": "\"{{work}}\" vence el {{dueDate}}. Asígnalo a alguien antes."
      },
      "reminderNoAsset": {
        "title": "Sigue sin haber nadie asignado",
        "body": "\"{{work}}\" vence el {{dueDate}}. Asígnalo a alguien o hazlo tú."
      },
      "raised": {
        "title": "Aún no hay nadie asignado",
        "body": "\"{{work}}\" · {{asset}} vence el {{dueDate}}. Asígnalo a alguien antes."
      },
      "reminder": {
        "title": "Sigue sin haber nadie asignado",
        "body": "\"{{work}}\" · {{asset}} vence el {{dueDate}}. Asígnalo a alguien o hazlo tú."
      }
    },
    "work_rescheduled": {
      "noInspection": {
        "title": "Reprogramado",
        "body": "Inspección · {{asset}} se ha movido al {{when}}."
      },
      "noInspectionNoAsset": {
        "title": "Reprogramado",
        "body": "La inspección se ha movido al {{when}}."
      },
      "noJob": {
        "title": "Reprogramado",
        "body": "Una orden de trabajo · {{asset}} se ha movido al {{when}}."
      },
      "noJobNoAsset": {
        "title": "Reprogramado",
        "body": "Una orden de trabajo se ha movido al {{when}}."
      },
      "default": {
        "title": "Reprogramado",
        "body": "{{work}} · {{asset}} se ha movido al {{when}}."
      },
      "noAsset": {
        "title": "Reprogramado",
        "body": "{{work}} se ha movido al {{when}}."
      }
    },
    "work_unscheduled": {
      "noInspection": {
        "title": "Sin programar",
        "body": "Inspección · {{asset}} ya no tiene fecha programada."
      },
      "noInspectionNoAsset": {
        "title": "Sin programar",
        "body": "La inspección ya no tiene fecha programada."
      },
      "noJob": {
        "title": "Sin programar",
        "body": "Una orden de trabajo · {{asset}} ya no tiene fecha programada."
      },
      "noJobNoAsset": {
        "title": "Sin programar",
        "body": "Una orden de trabajo ya no tiene fecha programada."
      },
      "default": {
        "title": "Sin programar",
        "body": "{{work}} · {{asset}} ya no tiene fecha programada."
      },
      "noAsset": {
        "title": "Sin programar",
        "body": "{{work}} ya no tiene fecha programada."
      }
    },
    "esg_certificate_expiring": {
      "expired": {
        "title": "Certificado energético caducado: {{place}}",
        "body": "El {{scheme}} (calificación {{rating}}) caduca el {{endDate}}. Reserve una nueva evaluación para poder seguir alquilando o vendiendo."
      },
      "inDays": {
        "title": "El certificado energético caduca en {{daysLeft}} días: {{place}}",
        "body": "El {{scheme}} (calificación {{rating}}) caduca el {{endDate}}. Reserve una nueva evaluación para poder seguir alquilando o vendiendo."
      }
    }
  },
  "lines": {
    "shareNotAcceptedOne": "Hace {{days}} día que {{waitingOn}} no acepta el acceso a este activo. Envíe un recordatorio o deje de compartirlo.",
    "shareNotAccepted": "Hace {{days}} días que {{waitingOn}} no acepta el acceso a este activo. Envíe un recordatorio o deje de compartirlo.",
    "expiredNotRenewedOne": "Caducó hace {{days}} día y nadie lo ha renovado.",
    "expiredNotRenewed": "Caducó hace {{days}} días y nadie lo ha renovado.",
    "fixNotConfirmedOne": "Hace {{days}} día que {{waitingOn}} no confirma la solución. Envíe un recordatorio.",
    "fixNotConfirmed": "Hace {{days}} días que {{waitingOn}} no confirma la solución. Envíe un recordatorio.",
    "notRedoneOne": "Hace {{days}} día que {{waitingOn}} no lo rehace. Envíe un recordatorio o reasígnelo.",
    "notRedone": "Hace {{days}} días que {{waitingOn}} no lo rehace. Envíe un recordatorio o reasígnelo.",
    "inviteNotAcceptedOne": "Hace {{days}} día que {{waitingOn}} no acepta la invitación. Reenvíela o retírela.",
    "inviteNotAccepted": "Hace {{days}} días que {{waitingOn}} no acepta la invitación. Reenvíela o retírela.",
    "approvedNoWorkOne": "Se aprobó hace {{days}} día y aún no se ha creado ningún trabajo.",
    "approvedNoWork": "Se aprobó hace {{days}} días y aún no se ha creado ningún trabajo.",
    "overdueOne": "Venció hace {{days}} día y aún no está hecho.",
    "overdue": "Venció hace {{days}} días y aún no está hecho.",
    "overdueUnassignedOne": "Venció hace {{days}} día y no hay nadie asignado. Asígnelo o hágalo usted mismo.",
    "overdueUnassigned": "Venció hace {{days}} días y no hay nadie asignado. Asígnelo o hágalo usted mismo.",
    "overdueNotDoneOne": "Venció hace {{days}} día y {{waitingOn}} no lo ha hecho. Reasígnelo o hágalo usted mismo.",
    "overdueNotDone": "Venció hace {{days}} días y {{waitingOn}} no lo ha hecho. Reasígnelo o hágalo usted mismo.",
    "quotesStalledOne": "Hace {{days}} día que estos presupuestos no avanzan. Adjudique uno, envíe un recordatorio o fije un plazo.",
    "quotesStalled": "Hace {{days}} días que estos presupuestos no avanzan. Adjudique uno, envíe un recordatorio o fije un plazo.",
    "awaitingYourValidationOne": "Pendiente de su validación desde hace {{days}} día.",
    "awaitingYourValidation": "Pendiente de su validación desde hace {{days}} días.",
    "quoteDeadlinePassedOne": "El plazo de los presupuestos venció hace {{days}} día. Adjudique uno, envíe un recordatorio o fije una nueva fecha.",
    "quoteDeadlinePassed": "El plazo de los presupuestos venció hace {{days}} días. Adjudique uno, envíe un recordatorio o fije una nueva fecha.",
    "awaitingYourPickupOne": "Pendiente de que usted lo asuma desde hace {{days}} día.",
    "awaitingYourPickup": "Pendiente de que usted lo asuma desde hace {{days}} días.",
    "awaitingYourApprovalOne": "Pendiente de su aprobación desde hace {{days}} día.",
    "awaitingYourApproval": "Pendiente de su aprobación desde hace {{days}} días.",
    "noResponseOne": "Sin respuesta de {{waitingOn}} desde hace {{days}} día.",
    "noResponse": "Sin respuesta de {{waitingOn}} desde hace {{days}} días.",
    "notValidatedOne": "Hace {{days}} día que {{waitingOn}} no lo valida.",
    "notValidated": "Hace {{days}} días que {{waitingOn}} no lo valida.",
    "inviteNotAnsweredOne": "Hace {{days}} día que {{waitingOn}} no responde a la invitación. Envíe un recordatorio o asigne a otra persona.",
    "inviteNotAnswered": "Hace {{days}} días que {{waitingOn}} no responde a la invitación. Envíe un recordatorio o asigne a otra persona.",
    "notRepliedOne": "Hace {{days}} día que {{waitingOn}} no responde.",
    "notReplied": "Hace {{days}} días que {{waitingOn}} no responde.",
    "notApprovedOne": "Hace {{days}} día que {{waitingOn}} no lo aprueba.",
    "notApproved": "Hace {{days}} días que {{waitingOn}} no lo aprueba."
  },
  "values": {
    "featureStatus": {
      "under_review": "en revisión",
      "planned": "planificada",
      "in_progress": "en desarrollo",
      "shipped": "ya en la aplicación",
      "not_planned": "sin planificar por ahora",
      "considering": "en estudio"
    },
    "reason": {
      "fault": "avería",
      "end_of_life": "fin de vida útil",
      "replaced": "sustituido",
      "seasonal": "parada de temporada",
      "relocated": "reubicado",
      "decommissioned": "dado de baja",
      "sold": "vendido",
      "disposed": "desechado",
      "lost": "perdido",
      "other": "otro"
    },
    "period": {
      "am": "por la mañana",
      "pm": "por la tarde"
    },
    "periodLabel": {
      "morning": "por la mañana",
      "afternoon": "por la tarde"
    },
    "documentType": {
      "certificate": "este certificado",
      "warranty": "esta garantía",
      "compliance_document": "este documento de cumplimiento",
      "document": "este documento"
    },
    "role": {
      "owner": "propietario",
      "admin": "administrador",
      "member": "miembro"
    },
    "action": {
      "skip": "Omisión",
      "reschedule": "Reprogramación",
      "reassign": "Reasignación"
    },
    "itemTitle": {
      "inspection": "Inspección",
      "job": "Orden de trabajo",
      "document": "Documento",
      "request": "Solicitud",
      "scheduled_inspection": "Inspección programada",
      "invitation_to_the_team": "Invitación al equipo"
    },
    "waitingOn": {
      "the_recipient": "el destinatario",
      "asset_approver": "el aprobador del activo",
      "the_approver": "el aprobador",
      "the_requester": "el solicitante",
      "the_assignee": "el responsable",
      "the_validator": "el validador",
      "the_team": "el equipo",
      "the_contractors_you_asked": "los contratistas a los que consultó",
      "the_contractor": "el contratista",
      "the_invitee": "el invitado",
      "nobody": "nadie",
      "The_recipient": "el destinatario",
      "The_approver": "el aprobador",
      "The_requester": "el solicitante",
      "The_assignee": "el responsable",
      "The_validator": "el validador",
      "The_team": "el equipo",
      "The_contractor": "el contratista",
      "The_invitee": "el invitado"
    }
  }
};
